import { documentSettingsAccess } from './pages/wf/approval-access';
import { withoutAccountingMode } from './accounting-mode-visibility';
import icon_dashboard from './assets/icons/white_dashboard.svg';
import icon_sale from './assets/icons/white_sale.svg';
import icon_sale2 from './assets/icons/white_sale2.svg';
import icon_cart from './assets/icons/white_cart.svg';
import icon_serve from './assets/icons/white_serve.svg';
import icon_appointment from './assets/icons/white_appointment.svg';
import icon_customer from './assets/icons/white_customer.svg';
import icon_commision from './assets/icons/white_commision.svg';
import icon_delivery from './assets/icons/white_delivery.svg';
import icon_inventory from './assets/icons/white_inventory.svg';
import icon_purchase from './assets/icons/white_purchase.svg';
import icon_supplychain from './assets/icons/white_supplychain.svg';
import icon_project from './assets/icons/white_project.svg';
import icon_expense from './assets/icons/white_expense.svg';
import icon_vendor from './assets/icons/white_vendor.svg';
import icon_cash from './assets/icons/white_cash.svg';
import icon_tax from './assets/icons/white_tax.svg';
import icon_employee from './assets/icons/white_employee.svg';
import icon_profit_lost from './assets/icons/white_profit_lost.svg';
import icon_report from './assets/icons/white_report.svg';
import icon_setting from './assets/icons/white_setting.svg';
import icon_permision from './assets/icons/white_permision.svg';
import icon_account from './assets/icons/white_account.svg';
import icon_procedure from './assets/icons/white_procedure.svg';
import icon_approval from './assets/icons/white_approval.svg';
import icon_table from './assets/icons/white_table.svg';
import icon_ticket from './assets/icons/white_ticket.svg';
import icon_payroll from './assets/icons/white_payroll.svg';
import icon_scissors from './assets/icons/white_scissors.svg';
import icon_general_ledger from './assets/icons/white_general_ledger.svg';

// Màn thuộc chế độ Kế toán: chỉ ẩn ở Vận hành với người vào được chế độ Kế toán (xem accounting-mode-visibility.js).
export { withoutAccountingMode };

export default [
    {
        text: {
            vi: 'Tổng quan',
            en: 'Dashboard',
            fr: 'Tableau de bord',
            es: 'Panel',
            id: 'Dasbor',
            ja: 'ダッシュボード',
            zh: '仪表板',
            ko: '대시보드',
            hi: 'डैशबोर्ड',
            ar: 'لوحة التحكم'
        },
        path: '/home',
        icon: icon_dashboard,
        visible: {
            whenUserScreen: 'Dashboard'
        },
        items: [
            // {
            //     text: {
            //         vi: 'Tổng quan',
            //         en: 'Overview',
            //         fr: 'Aperçu',
            //         es: 'Resumen',
            //         id: 'Ikhtisar',
            //         ja: '概要',
            //         zh: '概览',
            //         ko: '개요',
            //         hi: 'अवलोकन',
            //         ar: 'نظرة عامة'
            //     },
            //     path: '/home'
            // },
            {
                text: {
                    vi: 'Bán hàng',
                    en: 'Sales',
                    fr: 'Ventes',
                    es: 'Ventas',
                    id: 'Penjualan',
                    ja: '販売',
                    zh: '销售',
                    ko: '판매',
                    hi: 'बिक्री',
                    ar: 'مبيعات'
                },
                path: '/dashboard/sales',
                icon: icon_sale,
                visible: { whenSys: { use_Module_AR: 1 } }
            },
            {
                text: {
                    vi: 'Social',
                    en: 'Social',
                    fr: 'Social',
                    es: 'Social',
                    id: 'Social',
                    ja: 'ソーシャル',
                    zh: '社交',
                    ko: '소셜',
                    hi: 'सोशल',
                    ar: 'سوشيال'
                },
                path: '/dashboard/social',
                icon: icon_customer,
                visible: { whenSys: { use_Module_SocialChannel: 1 }, whenUser: { view_Module_SocialChannel: 1 } }
            },
            {
                text: {
                    vi: 'Marketing',
                    en: 'Marketing',
                    fr: 'Marketing',
                    es: 'Marketing',
                    id: 'Marketing',
                    ja: 'マーケティング',
                    zh: '营销',
                    ko: '마케팅',
                    hi: 'मार्केटिंग',
                    ar: 'التسويق'
                },
                path: '/dashboard/marketing',
                icon: icon_customer,
                visible: { whenSys: { use_Module_CRMMarketing: 1 }, whenUser: { view_Module_CRM: 1 } }
            },
            {
                text: {
                    vi: 'Khách hàng',
                    en: 'CRM',
                    fr: 'CRM',
                    es: 'CRM',
                    id: 'CRM',
                    ja: '顧客',
                    zh: '客户',
                    ko: '고객',
                    hi: 'ग्राहक',
                    ar: 'العملاء'
                },
                path: '/dashboard/crm',
                icon: icon_customer,
                visible: { whenSys: { use_Module_CRM: 1 }, whenUser: { view_Module_CRM: 1 } }
            },
            {
                text: {
                    vi: 'Mua hàng',
                    en: 'Purchasing',
                    fr: 'Achats',
                    es: 'Compras',
                    id: 'Pembelian',
                    ja: '購買',
                    zh: '采购',
                    ko: '구매',
                    hi: 'खरीद',
                    ar: 'المشتريات'
                },
                path: '/dashboard/purchase',
                icon: icon_purchase,
                visible: { whenSys: { use_Module_AP: 1 } }
            },
            {
                text: {
                    vi: 'Tiền mặt',
                    en: 'Cash',
                    fr: 'Trésorerie',
                    es: 'Efectivo',
                    id: 'Kas',
                    ja: '現金',
                    zh: '现金',
                    ko: '현금',
                    hi: 'नकदी',
                    ar: 'النقد'
                },
                path: '/dashboard/cash',
                icon: icon_cash,
                visible: { whenSys: { use_Module_CA: 1 } }
            },
            {
                text: {
                    vi: 'Tồn kho',
                    en: 'Inventory',
                    fr: 'Inventaire',
                    es: 'Inventario',
                    id: 'Inventaris',
                    ja: '在庫',
                    zh: '库存',
                    ko: '재고',
                    hi: 'इन्वेंटरी',
                    ar: 'المخزون'
                },
                path: '/dashboard/inventory',
                icon: icon_inventory,
                visible: { whenSys: { use_Module_IC: 1 } }
            },
            {
                text: {
                    vi: 'Sản xuất',
                    en: 'Manufacturing',
                    fr: 'Production',
                    es: 'Producción',
                    id: 'Manufaktur',
                    ja: '製造',
                    zh: '生产',
                    ko: '생산',
                    hi: 'विनिर्माण',
                    ar: 'التصنيع'
                },
                path: '/dashboard/manufacturing',
                icon: icon_procedure,
                visible: { whenSys: { use_Module_MF: 1 }, whenUser: { view_Module_MF: 1 } }
            },
            {
                text: {
                    vi: 'Giao hàng',
                    en: 'Delivery',
                    fr: 'Livraison',
                    es: 'Entrega',
                    id: 'Pengiriman',
                    ja: '配送',
                    zh: '配送',
                    ko: '배송',
                    hi: 'डिलीवरी',
                    ar: 'التوصيل'
                },
                path: '/dashboard/delivery',
                icon: icon_delivery,
                visible: { whenSys: { use_Module_LG: 1 } }
            },
            {
                text: {
                    vi: 'Chi phí',
                    en: 'Expense',
                    fr: 'Dépenses',
                    es: 'Gastos',
                    id: 'Biaya',
                    ja: '費用',
                    zh: '费用',
                    ko: '비용',
                    hi: 'खर्च',
                    ar: 'المصروفات'
                },
                path: '/dashboard/expense',
                icon: icon_expense,
                visible: { whenSys: { use_Module_EXP: 1 } }
            },
            {
                text: {
                    vi: 'Lãi lỗ',
                    en: 'Profit & Loss',
                    fr: 'Résultat',
                    es: 'Pérdidas y Ganancias',
                    id: 'Laba Rugi',
                    ja: '損益',
                    zh: '损益',
                    ko: '손익',
                    hi: 'लाभ और हानि',
                    ar: 'الأرباح والخسائر'
                },
                path: '/dashboard/profitloss',
                icon: icon_profit_lost,
                visible: { whenSys: { use_Module_PNL: 1, use_Module_GL: { type: '!=', value: 1 } } }
            },
            {
                text: {
                    vi: 'Kế toán',
                    en: 'Accounting',
                    fr: 'Comptabilité',
                    es: 'Contabilidad',
                    id: 'Akuntansi',
                    ja: '会計',
                    zh: '会计',
                    ko: '회계',
                    hi: 'लेखांकन',
                    ar: 'المحاسبة'
                },
                path: '/dashboard/accounting',
                icon: icon_general_ledger,
                visible: withoutAccountingMode({ whenSys: { use_Module_GL: 1 }, whenUser: { view_Module_GL: 1 } })
            },
            {
                text: {
                    vi: 'Chấm công',
                    en: 'Timesheet',
                    fr: 'Présence',
                    es: 'Asistencia',
                    id: 'Kehadiran',
                    ja: '出勤',
                    zh: '出勤',
                    ko: '출근',
                    hi: 'उपस्थिति',
                    ar: 'الحضور'
                },
                path: '/dashboard/timesheet',
                icon: icon_employee,
                visible: { whenUserScreen: 'HRWorkingTimesheets', whenSys: { use_Module_HRM: 1, use_Module_Timesheet: 1 } }
            },
            {
                text: {
                    vi: 'Phê duyệt',
                    en: 'Approvals',
                    fr: 'Approbations en attente',
                    es: 'Aprobaciones pendientes',
                    id: 'Persetujuan tertunda',
                    ja: '承認待ち',
                    zh: '待审批',
                    ko: '승인 대기',
                    hi: 'लंबित अनुमोदन',
                    ar: 'الموافقات المعلقة'
                },
                path: '/wf/WFApprovalPendings',
                icon: icon_approval,
                visible: [
                    { whenSys: { use_Module_Approval: 1 }, whenUser: { Approval_request_approval: 1 } },
                    { whenSys: { use_Module_Approval: 1 }, whenUser: { Approval_can_approve: 1 } },
                    { whenUserScreen: 'WFApprovalPendings' }
                ]
            }
        ]
    },
    {
        text: [
            {
                when: {
                    whenSys: { ARServe_use_table: 1 }
                },
                value: {
                    vi: 'Sơ đồ bàn',
                    en: 'Table Map',
                    fr: 'Plan des tables',
                    es: 'Mapa de mesas',
                    id: 'Peta meja',
                    ja: 'テーブルマップ',
                    zh: '餐桌地图',
                    ko: '테이블 맵',
                    hi: 'टेबल मैप',
                    ar: 'خريطة الطاولات'
                }
            },
            {
                when: {
                    whenSys: { ARServe_use_room: 1 }
                },
                value: {
                    vi: 'Sơ đồ phòng',
                    en: 'Room Map',
                    fr: 'Plan des chambres',
                    es: 'Mapa de habitaciones',
                    id: 'Peta kamar',
                    ja: '部屋マップ',
                    zh: '房间地图',
                    ko: '객실 맵',
                    hi: 'रूम मैप',
                    ar: 'خريطة الغرف'
                }
            },
            {
                when: {
                    whenSys: { ARServe_use_seat: 1 }
                },
                value: {
                    vi: 'Sơ đồ ghế',
                    en: 'Seat Map',
                    fr: 'Plan des sièges',
                    es: 'Mapa de asientos',
                    id: 'Peta kursi',
                    ja: '座席マップ',
                    zh: '座位地图',
                    ko: '좌석 맵',
                    hi: 'सीट मैप',
                    ar: 'خريطة المقاعد'
                }
            },
            {
                when: {
                    whenSys: { ARServe_use_field: 1 }
                },
                value: {
                    vi: 'Sơ đồ sân',
                    en: 'Field Map',
                    fr: 'Plan des terrains',
                    es: 'Mapa de campos',
                    id: 'Peta lapangan',
                    ja: 'フィールドマップ',
                    zh: '场地地图',
                    ko: '필드 맵',
                    hi: 'मैदान मैप',
                    ar: 'خريطة الملاعب'
                }
            },
            {
                vi: 'Bàn Phòng',
                en: 'Room/Table',
                fr: 'Chambre/Table',
                es: 'Habitación/Mesa',
                id: 'Kamar/Meja',
                ja: '部屋/テーブル',
                zh: '房间/餐桌',
                ko: '객실/테이블',
                hi: 'कमरा/टेबल',
                ar: 'الغرفة/الطاولة'
            }
        ],
        path: '/serve/ARServeStatuses',
        icon: icon_table,
        visible: {
            whenUserScreen: 'ARServeStatuses'
        },
        navBadge: { module: 'serve', table: 'ARServeStatus', searchConditions: { serve_status: 'Serving' } }
    },
    {
        text: {
            vi: 'Hàng Bán',
            en: 'Catalogue',
            fr: 'Catalogue',
            es: 'Catálogo',
            id: 'Katalog',
            ja: 'カタログ',
            zh: '目录',
            ko: '카탈로그',
            hi: 'सूची',
            ar: 'الفهرس'
        },
        icon: icon_sale,
        path: '/ar/ARItemStatuses',
        visible: {
            whenUserScreen: 'ARItemStatuses'
        }
    },
    {
        text: {
            vi: 'Lịch hẹn',
            en: 'Appointment',
            fr: 'Rendez-vous',
            es: 'Cita',
            id: 'Janji',
            ja: '予約',
            zh: '预约',
            ko: '예약',
            hi: 'नियुक्ति',
            ar: 'موعد'
        },
        icon: 'clock',
        items: [
            {
                text: {
                    vi: 'Lịch hẹn',
                    en: 'Appointment',
                    fr: 'Rendez-vous',
                    es: 'Cita',
                    id: 'Janji',
                    ja: '予約',
                    zh: '预约',
                    ko: '예약',
                    hi: 'नियुक्ति',
                    ar: 'موعد'
                },
                path: '/ar/ARAppointments',
                visible: {
                    whenUserScreen: 'ARAppointments'
                },
                navBadge: {
                    module: 'ar',
                    table: 'ARAppointment',
                    searchConditions: {
                        appointment_status: ['Release', 'Open']
                    }
                }
            }
        ]
    },
    {
        text: {
            vi: 'Đặt chỗ',
            en: 'Rental Bookings',
            fr: 'Réservations',
            es: 'Reservas',
            id: 'Pemesanan',
            ja: '予約',
            zh: '预订',
            ko: '예약',
            hi: 'बुकिंग',
            ar: 'الحجوزات'
        },
        icon: icon_appointment,
        path: '/rental/ARBookings',
        visible: {
            whenUserScreen: 'ARRentalRoomBookings'
        },
        navBadge: {
            module: 'rental',
            table: 'ARRentalBooking',
            searchConditions: {
                booking_status: ['Release', 'Open', 'Close'],
                checked_in_at: 'IsNull'
            }
        }
    },
    {
        text: {
            vi: 'Đặt phòng',
            en: 'Room Booking',
            fr: 'Réservation chambre',
            es: 'Reserva habitación',
            id: 'Pemesanan kamar',
            ja: '客室予約',
            zh: '房间预订',
            ko: '객실 예약',
            hi: 'कमरा बुकิंग',
            ar: 'حجز الغرفة'
        },
        icon: icon_appointment,
        path: '/rental/ARRentalRoomBookings',
        visible: false
    },
    {
        text: {
            vi: 'Cho thuê xe',
            en: 'Vehicle Rental',
            fr: 'Location véhicule',
            es: 'Alquiler vehículo',
            id: 'Sewa kendaraan',
            ja: '車両レンタル',
            zh: '车辆租赁',
            ko: '차량 대여',
            hi: 'वाहन किराया',
            ar: 'تأجير المركبة'
        },
        icon: icon_appointment,
        path: '/rental/ARRentalVehicleBookings',
        visible: false
    },
    {
        text: {
            vi: 'Đặt sân',
            en: 'Field Booking',
            fr: 'Réservation terrain',
            es: 'Reserva cancha',
            id: 'Pemesanan lapangan',
            ja: 'コート予約',
            zh: '场地预订',
            ko: '경기장 예약',
            hi: 'मैदान बुकिंग',
            ar: 'حجز الملعب'
        },
        icon: icon_appointment,
        path: '/rental/ARRentalFieldBookings',
        visible: {
            whenUserScreen: 'ARRentalFieldBookings'
        },
        navBadge: {
            module: 'rental',
            table: 'ARRentalBooking',
            searchConditions: {
                booking_status: ['Release', 'Open', 'Close'],
                checked_in_at: 'IsNull'
            }
        }
    },
    {
        // Hội thoại (SocialDesk) — chat đa kênh → chốt đơn. Đặt trong module Bán hàng, NGAY TRÊN
        // "Đơn từ kênh" (luồng: chat khách → tạo đơn). Gate whenUserScreen 'Conversations'.
        text: {
            vi: 'Hội thoại',
            en: 'Conversations',
            fr: 'Conversations',
            es: 'Conversaciones',
            id: 'Percakapan',
            ja: '会話',
            zh: '会话',
            ko: '대화',
            hi: 'बातचीत',
            ar: 'المحادثات'
        },
        path: '/socialChannel/Conversations',
        icon: icon_customer,
        visible: { whenUserScreen: 'Conversations' }
    },
    {
        // Đơn từ kênh ngoài (sàn TMĐT + mạng xã hội) — multi-tab page,
        // unified entry để tạo AROrder. Đặt TRƯỚC AROrders để user thấy đơn
        // pending từ kênh trước, xử lý → tạo AROrder.
        text: {
            vi: 'Đơn từ kênh',
            en: 'Channel Orders',
            fr: 'Commandes canal',
            es: 'Pedidos canal',
            id: 'Pesanan kanal',
            ja: 'チャネル注文',
            zh: '渠道订单',
            ko: '채널 주문',
            hi: 'चैनल ऑर्डर',
            ar: 'طلبات القناة'
        },
        path: '/integration/Orders',
        icon: icon_cart,
        // Hiện khi system có ít nhất 1 module sale/social bật. Per-tab visibility
        // (IntegrationOrdersSale/Social ACL) xử lý trong chính page IntegrationOrders
        // qua AntCondition.isValid filter visibleTabs. Tránh ép user re-login để
        // session sync 2 screens mới.
        visible: {
            when: {
                gr_sale: { whenSys: { use_Module_SaleChannel: 1 } },
                gr_social: { whenSys: { use_Module_SocialChannel: 1 } }
            },
            whenType: 'OR'
        }
    },
    {
        text: {
            vi: 'Đơn Hàng',
            en: 'Sale Order',
            fr: 'Commande vente',
            es: 'Pedido venta',
            id: 'Pesanan penjualan',
            ja: '販売注文',
            zh: '销售订单',
            ko: '판매 주문',
            hi: 'बिक्री आदेश',
            ar: 'أمر البيع'
        },
        path: '/ar/AROrders',
        icon: icon_cart,
        visible: {
            whenUserScreen: 'AROrders'
        },
        navBadge: { module: 'ar', table: 'AROrder', searchGroup: 'released' }
    },
    {
        text: {
            vi: 'Trả Hàng',
            en: 'Sale Return',
            fr: 'Retour vente',
            es: 'Devolución venta',
            id: 'Retur penjualan',
            ja: '販売返品',
            zh: '销售退货',
            ko: '판매 반품',
            hi: 'बिक्री वापसी',
            ar: 'إرجاع البيع'
        },
        icon: 'undo',
        path: '/ar/ARReturns',
        visible: {
            whenUserScreen: 'ARReturns'
        },
        navBadge: {
            module: 'ar',
            table: 'ARShipmentItem',
            searchConditions: {
                item_type: ['Good', 'Food', 'Beverage', 'Material', 'Consumable'],
                shipment_type: 'Return',
                shipment_status: ['Release', 'Open'],
                item_delivery_status: ['Release', 'Open']
            }
        }
    },
    {
        text: {
            vi: 'Dịch vụ',
            en: 'Service',
            fr: 'Service',
            es: 'Servicio',
            id: 'Layanan',
            ja: 'サービス',
            zh: '服务',
            ko: '서비스',
            hi: 'सेवा',
            ar: 'الخدمة'
        },
        icon: icon_scissors,
        distinctable: true,
        items: [
            {
                text: {
                    vi: 'Dịch vụ',
                    en: 'Service',
                    fr: 'Service',
                    es: 'Servicio',
                    id: 'Layanan',
                    ja: 'サービス',
                    zh: '服务',
                    ko: '서비스',
                    hi: 'सेवा',
                    ar: 'الخدمة'
                },
                path: '/serve/ARServeServices',
                // icon: icon_customer,
                visible: {
                    whenUserScreen: 'ARServeServices'
                },
                navBadge: {
                    module: 'ar',
                    table: 'ARDeliveryItem',
                    searchConditions: {
                        searchForFixedService: true,
                        order_status: ['Release', 'Open', 'Close'],
                        delivery_item_status: ['New', 'Release', 'Open'],
                        serve_actual_end_at: 'IsNull'
                    }
                }
            },
            {
                text: {
                    vi: 'Kế hoạch',
                    en: 'Service Plans'
                },
                path: '/ar/ARServicePlans',
                visible: {
                    whenUserScreen: 'ARServicePlans'
                },
                navBadge: { module: 'ar', table: 'ARServicePlan', searchConditions: { plan_status: ['Release', 'Open'] } }
            },
            {
                text: {
                    vi: 'Thẻ dịch vụ',
                    en: 'Service Card',
                    fr: 'Carte service',
                    es: 'Tarjeta servicio',
                    id: 'Kartu layanan',
                    ja: 'サービスカード',
                    zh: '服务卡',
                    ko: '서비스 카드',
                    hi: 'सेवा कार्ड',
                    ar: 'بطاقة الخدمة'
                },
                path: '/ar/ServiceCards',
                icon: icon_ticket,
                visible: {
                    whenUserScreen: 'ServiceCards'
                }
            },
            {
                text: {
                    vi: 'Sửa chữa',
                    en: 'Repair'
                },
                path: '/ar/ARServiceOrders',
                visible: {
                    whenUserScreen: 'ARServiceOrders'
                },
                navBadge: {
                    module: 'ar',
                    table: 'ARServiceOrder',
                    searchConditions: { service_order_status: ['Reception', 'Diagnosis', 'Quoted', 'Approved'] }
                }
            },
            {
                text: {
                    vi: 'Thu cũ đổi mới',
                    en: 'Trade-In'
                },
                path: '/ar/ARTradeIns',
                visible: {
                    whenUserScreen: 'ARTradeIns'
                },
                navBadge: { module: 'ar', table: 'ARTradeIn', searchConditions: { tradein_status: ['New', 'Appraising', 'Approved'] } }
            },
            {
                text: {
                    vi: 'Bảo hành',
                    en: 'Warranty'
                },
                path: '/ar/ARWarranties',
                visible: {
                    whenUserScreen: 'ARWarranties'
                },
                navBadge: { module: 'ar', table: 'ARWarranty', searchConditions: { warranty_status: 'Active' } }
            },
            {
                text: {
                    vi: 'Yêu cầu bảo hành',
                    en: 'Warranty Claims'
                },
                path: '/ar/ARWarrantyClaims',
                visible: {
                    whenUserScreen: 'ARWarrantyClaims'
                },
                navBadge: {
                    module: 'ar',
                    table: 'ARWarrantyClaim',
                    searchConditions: { claim_status: ['Received', 'Diagnosing', 'Repairing', 'WaitPart'] }
                }
            },
            // {
            //     text: {
            //         vi: 'Dùng thử',
            //         en: 'Trial'
            //     },
            //     path: '/ar/ARProductTrials',
            //     visible: {
            //         whenUserScreen: 'ARProductTrials'
            //     }
            // },
            // {
            //     text: {
            //         vi: 'Kiểm tra giao hàng',
            //         en: 'Delivery Inspection'
            //     },
            //     path: '/ar/ARDeliveryInspections',
            //     visible: {
            //         whenUserScreen: 'ARDeliveryInspections'
            //     }
            // }
            // {
            //     text: {
            //         vi: 'Chiến dịch',
            //         en: 'Campaign'
            //     },
            //     path: '/ar/ARProductCampaigns',
            //     visible: {
            //         whenUserScreen: 'ARProductCampaigns'
            //     }
            // },
            {
                text: {
                    vi: 'Tài sản khách',
                    en: 'Assets'
                },
                path: '/ar/CustomerAssets',
                visible: {
                    whenUserScreen: 'CustomerAssets'
                },
                navBadge: { module: 'ar', table: 'CustomerAsset', searchConditions: { asset_status: 'InService' } }
            },
            // {
            //     text: {
            //         vi: 'Trả góp',
            //         en: 'Financing'
            //     },
            //     path: '/ar/ARFinancingPlans',
            //     icon: 'money',
            //     visible: {
            //         whenUserScreen: 'ARFinancingPlans'
            //     }
            // },
            // {
            //     text: {
            //         vi: 'Bảo hiểm',
            //         en: 'Coverage'
            //     },
            //     path: '/ar/ARCoveragePlans',
            //     icon: 'shield',
            //     visible: {
            //         whenUserScreen: 'ARCoveragePlans'
            //     }
            // },
            {
                text: {
                    vi: 'Đăng ký tài sản',
                    en: 'Registration'
                },
                path: '/ar/ARAssetRegistrations',
                visible: {
                    whenUserScreen: 'ARAssetRegistrations'
                },
                navBadge: {
                    module: 'ar',
                    table: 'ARAssetRegistration',
                    searchConditions: { registration_status: ['DocumentCollected', 'Submitted', 'Processing', 'Approved', 'PlateAssigned'] }
                }
            },
            {
                text: {
                    vi: 'Kế hoạch bảo dưỡng',
                    en: 'Maintain Plans'
                },
                path: '/ar/ARMaintainPlans',
                visible: {
                    whenUserScreen: 'ARMaintainPlans'
                }
            },
            {
                text: {
                    vi: 'Nhắc bảo dưỡng',
                    en: 'Reminders'
                },
                path: '/ar/ARMaintainReminders',
                visible: {
                    whenUserScreen: 'ARMaintainReminders'
                },
                navBadge: { module: 'ar', table: 'ARMaintainReminder', searchConditions: { remind_status: 'Pending' } }
            }
        ]
    },
    {
        text: {
            vi: 'Thẻ trả trước',
            en: 'Deposit Card',
            fr: 'Carte dépôt',
            es: 'Tarjeta depósito',
            id: 'Kartu deposit',
            ja: 'デポジットカード',
            zh: '押金卡',
            ko: '보증금 카드',
            hi: 'जमा कार्ड',
            ar: 'بطاقة الإيداع'
        },
        icon: icon_ticket,
        items: [
            {
                text: {
                    vi: 'Thẻ trả trước',
                    en: 'Deposit Card',
                    fr: 'Carte dépôt',
                    es: 'Tarjeta depósito',
                    id: 'Kartu deposit',
                    ja: 'デポジットカード',
                    zh: '押金卡',
                    ko: '보증금 카드',
                    hi: 'जमा कार्ड',
                    ar: 'بطاقة الإيداع'
                },
                path: '/ar/DepositCards',
                visible: {
                    whenUserScreen: 'DepositCards'
                }
            }
        ]
    },
    {
        text: {
            vi: 'Chế biến (Cũ)',
            en: 'Cooking (Legacy)',
            fr: 'Cuisine (Legacy)',
            es: 'Cocina (Legacy)',
            id: 'Memasak (Legacy)',
            ja: '調理 (Legacy)',
            zh: '烹饪 (Legacy)',
            ko: '조리 (Legacy)',
            hi: 'खाना बनाना (Legacy)',
            ar: 'الطبخ (Legacy)'
        },
        path: '/serve/ARServeCookingsLegacy',
        icon: icon_serve,
        visible: false,
        navBadge: {
            module: 'ar',
            table: 'ARDeliveryItem',
            searchConditions: {
                searchForCooking: true,
                order_status: ['Release', 'Open', 'Close'],
                delivery_item_status: ['New', 'Release', 'Open'],
                serve_actual_start_at: 'IsNull'
            }
        }
    },
    {
        text: {
            vi: 'Chế biến',
            en: 'Cooking',
            fr: 'Cuisine',
            es: 'Cocina',
            id: 'Memasak',
            ja: '調理',
            zh: '烹饪',
            ko: '조리',
            hi: 'खाना बनाना',
            ar: 'الطبخ'
        },
        path: '/serve/ARServeCookings',
        icon: icon_serve,
        visible: {
            whenUserScreen: 'ARServeCookings'
        },
        navBadge: {
            module: 'ar',
            table: 'ARDeliveryItem',
            searchConditions: {
                searchForCooking: true,
                order_status: ['Release', 'Open', 'Close'],
                delivery_item_status: ['New', 'Release', 'Open'],
                serve_actual_end_at: 'IsNull'
            }
        }
    },
    {
        text: {
            vi: 'Lên món',
            en: 'Delivery',
            fr: 'Livraison',
            es: 'Entrega',
            id: 'Pengiriman',
            ja: '配膳',
            zh: '上菜',
            ko: '서빙',
            hi: 'डिलीवरी',
            ar: 'التقديم'
        },
        path: '/serve/ARServeDeliveries',
        icon: icon_serve,
        visible: {
            whenUserScreen: 'ARServeDeliveries'
        },
        navBadge: {
            module: 'ar',
            table: 'ARDeliveryItem',
            searchConditions: {
                searchForCooking: true,
                order_status: ['Release', 'Open', 'Close'],
                delivery_item_status: ['New', 'Release', 'Open'],
                serve_actual_prepared_at: 'NotNull',
                serve_actual_end_at: 'IsNull'
            }
        }
    },
    {
        text: {
            vi: 'Khách Hàng',
            en: 'Customer',
            fr: 'Client',
            es: 'Cliente',
            id: 'Pelanggan',
            ja: '顧客',
            zh: '客户',
            ko: '고객',
            hi: 'ग्राहक',
            ar: 'العميل'
        },
        path: '/crm/Customers',
        icon: icon_customer,
        // Chỉ ở tab Bán hàng khi có AR; gói Kế toán không AR dùng mục Khách hàng trong nhóm Phải thu.
        visible: {
            whenUserScreen: 'Customers',
            whenSys: { use_Module_AR: 1 }
        }
    },
    {
        text: {
            vi: 'Khách mới',
            en: 'Lead',
            fr: 'Prospect',
            es: 'Prospecto',
            id: 'Prospek',
            ja: 'リード',
            zh: '线索',
            ko: '리드',
            hi: 'लीड',
            ar: 'العميل المحتمل'
        },
        icon: icon_customer,
        items: [
            {
                text: {
                    vi: 'Khách Tiềm Năng',
                    en: 'Lead',
                    fr: 'Prospect',
                    es: 'Prospecto',
                    id: 'Prospek',
                    ja: 'リード',
                    zh: '线索',
                    ko: '리드',
                    hi: 'लीड',
                    ar: 'العميل المحتمل'
                },
                path: '/crm/CRMLeads',
                icon: icon_customer,
                visible: {
                    whenUserScreen: 'CRMLeads'
                },
                navBadge: { module: 'crm', table: 'CRMLead', searchConditions: { type: 'Lead', last_contacted_at: 'IsNull' } }
            },
            {
                text: {
                    vi: 'Lead từ AI',
                    en: 'AI Leads',
                    fr: 'Prospects IA',
                    es: 'Prospectos IA',
                    id: 'Prospek AI',
                    ja: 'AIリード',
                    zh: 'AI 线索',
                    ko: 'AI 리드',
                    hi: 'AI लीड',
                    ar: 'عملاء AI'
                },
                path: '/crm/CRMLeadIntake',
                icon: icon_customer,
                visible: {
                    whenUserScreen: 'CRMLeads',
                    whenSys: { use_Module_AIWithKey: 1 }
                }
            },
            {
                text: {
                    vi: 'Tiếp cận khách',
                    en: 'Activities',
                    fr: 'Activités',
                    es: 'Actividades',
                    id: 'Aktivitas',
                    ja: '活動',
                    zh: '活动',
                    ko: '활동',
                    hi: 'गतिविधियां',
                    ar: 'الأنشطة'
                },
                path: '/crm/CRMLeadActivities',
                icon: icon_customer,
                visible: {
                    whenUserScreen: 'CRMLeadActivities'
                },
                navBadge: { module: 'crm', table: 'CRMLeadActivity', searchConditions: { activity_status: 'New' } }
            }
        ]
    },
    {
        text: {
            vi: 'Hỗ trợ',
            en: 'Support',
            fr: 'Support',
            es: 'Soporte',
            id: 'Dukungan',
            ja: 'サポート',
            zh: '支持',
            ko: '지원',
            hi: 'सहायता',
            ar: 'الدعم'
        },
        path: '/crm/CRMTickets',
        icon: icon_customer,
        visible: {
            whenUserScreen: 'CRMTickets'
        }
    },
    {
        text: {
            vi: 'Chiến dịch',
            en: 'Campaigns',
            fr: 'Campagnes',
            es: 'Campañas',
            id: 'Kampanye',
            ja: 'キャンペーン',
            zh: '营销活动',
            ko: '캠페인',
            hi: 'अभियान',
            ar: 'الحملات'
        },
        path: '/crm/CRMCampaigns',
        icon: icon_customer,
        visible: {
            whenUserScreen: 'CRMCampaigns'
        }
    },
    {
        text: {
            vi: 'Giao hàng',
            en: 'Delivery',
            fr: 'Livraison',
            es: 'Entrega',
            id: 'Pengiriman',
            ja: '配送',
            zh: '配送',
            ko: '배송',
            hi: 'डिलीवरी',
            ar: 'التوصيل'
        },
        icon: icon_delivery,
        items: [
            {
                text: {
                    vi: 'Xuất hàng',
                    en: 'Fulfillment',
                    fr: 'Exécution',
                    es: 'Cumplimiento',
                    id: 'Pemenuhan',
                    ja: '処理',
                    zh: '履行',
                    ko: '이행',
                    hi: 'पूर्ति',
                    ar: 'التنفيذ'
                },
                path: '/ar/ARIssues',
                visible: {
                    whenUserScreen: 'ARIssues',
                    whenSession: {
                        entity_type: { type: '!=', value: 'Customer' }
                    }
                },
                navBadge: {
                    module: 'ar',
                    table: 'ARIssue',
                    searchConditions: { shipment_status: ['Release', 'Open'] }
                }
            },
            {
                text: {
                    vi: 'Vận đơn',
                    en: 'Transport',
                    fr: 'Transport',
                    es: 'Transporte',
                    id: 'Transportasi',
                    ja: '輸送',
                    zh: '运输',
                    ko: '운송',
                    hi: 'परिवहन',
                    ar: 'النقل'
                },
                path: '/lg/LGTransports',
                visible: {
                    whenUserScreen: 'LGTransports',
                    whenSession: {
                        entity_type: { type: '!=', value: 'Customer' }
                    }
                },
                navBadge: {
                    module: 'lg',
                    table: 'LGTransport',
                    searchConditions: { transport_status: ['Release', 'Posted', 'Picked', 'Returning'] }
                }
            },
            {
                text: {
                    vi: 'Lịch sử vận đơn',
                    en: 'Logistics Logs',
                    fr: 'Journaux logistique',
                    es: 'Registros logística',
                    id: 'Log logistik',
                    ja: '物流ログ',
                    zh: '物流日志',
                    ko: '물류 로그',
                    hi: 'लॉजिस्टिक्स लॉग',
                    ar: 'سجلات اللوجستيات'
                },
                path: '/lg/LGLogs',
                visible: {
                    whenUserScreen: 'LGLogs',
                    whenSession: {
                        user_group_code: ['Admin']
                    }
                }
            }
        ]
    },
    {
        text: {
            vi: 'Nạp tiền',
            en: 'Deposit',
            fr: 'Dépôt',
            es: 'Depósito',
            id: 'Deposit',
            ja: '預金',
            zh: '押金',
            ko: '보증금',
            hi: 'जमा',
            ar: 'إيداع'
        },
        path: '/wallet/WalletTrans',
        icon: icon_cash,
        visible: {
            whenUserScreen: 'WalletTrans'
        }
    },
    // {
    //     text: {
    //         vi: 'Tích điểm',
    //         en: 'Loyalty'
    //     },
    //     path: '/loyalty/CRMLoyaltyDetails',
    //     icon: icon_customer,
    //     visible: {
    //         whenUserScreen: 'CRMLoyaltyDetails'
    //     }
    // },
    {
        text: {
            vi: 'Sự kiện',
            en: 'Event',
            fr: 'Événement',
            es: 'Evento',
            id: 'Acara',
            ja: 'イベント',
            zh: '活动',
            ko: '이벤트',
            hi: 'इवेंट',
            ar: 'الحدث'
        },
        icon: icon_ticket,
        items: [
            {
                text: {
                    vi: 'Bán vé',
                    en: 'Event Session',
                    fr: 'Session événement',
                    es: 'Sesión evento',
                    id: 'Sesi acara',
                    ja: 'イベントセッション',
                    zh: '活动场次',
                    ko: '이벤트 세션',
                    hi: 'इवेंट सेशन',
                    ar: 'جلسة الحدث'
                },
                path: '/event/AREventSessionStatuses',
                visible: {
                    whenUserScreen: 'AREvents'
                },
                navBadge: {
                    module: 'event',
                    table: 'AREventSessionStatus',
                    searchConditions: {
                        event_is_active: 1,
                        event_status: ['Release', 'Open', 'Close'],
                        session_status: ['Release', 'Open'],
                        session_start_at_today: true
                    }
                }
            },
            // {
            //     text: 'Phiên sự kiện',
            //     path: '/event/AREventSessions',
            //     visible: {
            //         whenUserScreen: 'AREvents'
            //     }
            // },
            {
                text: {
                    vi: 'Vé sự kiện',
                    en: 'Event Ticket',
                    fr: 'Billet événement',
                    es: 'Boleto evento',
                    id: 'Tiket acara',
                    ja: 'イベントチケット',
                    zh: '活动门票',
                    ko: '이벤트 티켓',
                    hi: 'इवेंट टिकट',
                    ar: 'تذكرة الحدث'
                },
                path: '/event/AREventTickets',
                visible: {
                    whenUserScreen: 'AREvents'
                },
                navBadge: {
                    module: 'event',
                    table: 'AREventTicket',
                    searchConditions: {
                        event_is_active: 1,
                        event_status: ['Release', 'Open', 'Close'],
                        session_status: ['Release', 'Open'],
                        ticket_status: ['Paid', 'CheckedIn'],
                        session_start_at_today: true
                    }
                }
            },
            {
                text: {
                    vi: 'Sự kiện',
                    en: 'Event',
                    fr: 'Événement',
                    es: 'Evento',
                    id: 'Acara',
                    ja: 'イベント',
                    zh: '活动',
                    ko: '이벤트',
                    hi: 'इवेंट',
                    ar: 'الحدث'
                },
                path: '/event/AREvents',
                visible: {
                    whenUserScreen: 'AREvents'
                }
            }
        ]
    },
    {
        text: {
            vi: 'Vé xe',
            en: 'Travel',
            fr: 'Voyage',
            es: 'Viaje',
            id: 'Perjalanan',
            ja: '旅行',
            zh: '旅行',
            ko: '여행',
            hi: 'यात्रा',
            ar: 'السفر'
        },
        icon: icon_ticket,
        items: [
            {
                text: {
                    vi: 'Chuyến xe',
                    en: 'Trip',
                    fr: 'Trajet',
                    es: 'Viaje',
                    id: 'Perjalanan',
                    ja: '運行',
                    zh: '行程',
                    ko: '운행',
                    hi: 'यात्रा',
                    ar: 'الرحلة'
                },
                path: '/travel/ARTravelSessions',
                visible: {
                    whenUserScreen: 'ARTravels'
                },
                navBadge: {
                    module: 'travel',
                    table: 'ARTravelSession',
                    searchConditions: {
                        travel_is_active: 1,
                        travel_status: ['Release', 'Open', 'Close'],
                        session_status: ['Release', 'Open'],
                        session_start_at_today: true
                    }
                }
            },
            {
                text: {
                    vi: 'Hành trình',
                    en: 'Journey',
                    fr: 'Itinéraire',
                    es: 'Itinerario',
                    id: 'Perjalanan',
                    ja: '行程',
                    zh: '路线',
                    ko: '여정',
                    hi: 'यात्रा',
                    ar: 'الرحلة'
                },
                path: '/travel/ARTravels',
                visible: {
                    whenUserScreen: 'ARTravels'
                }
            }
        ]
    },
    {
        text: {
            vi: 'Kiểm vật tư',
            en: 'Count Material',
            fr: 'Comptage matière',
            es: 'Conteo material',
            id: 'Hitung bahan',
            ja: '材料棚卸',
            zh: '盘点材料',
            ko: '자재 집계',
            hi: 'सामग्री गणना',
            ar: 'عد المواد'
        },
        path: '/serve/ARServeMaterialCountings',
        icon: icon_inventory,
        visible: {
            whenUserScreen: 'ARServeMaterialCountings'
        },
        navBadge: {
            module: 'ar',
            table: 'ARServeMaterialCounting',
            searchConditions: { counting_status: 'New' }
        }
    },
    {
        text: {
            vi: 'Xuất vật tư',
            en: 'Issue Material',
            fr: 'Sortie matière',
            es: 'Salida material',
            id: 'Keluarkan bahan',
            ja: '材料出庫',
            zh: '发放材料',
            ko: '자재 출고',
            hi: 'सामग्री निर्गम',
            ar: 'إصدار المواد'
        },
        path: '/serve/ARServeMaterialIssues',
        icon: icon_inventory,
        visible: {
            whenUserScreen: 'ARServeMaterialIssues'
        },
        navBadge: { module: 'serve', table: 'ARServeMaterialIssue', searchConditions: { status: ['New', 'Release', 'Open'] } }
    },
    {
        text: {
            vi: 'Tồn Kho',
            en: 'Inventory',
            fr: 'Inventaire',
            es: 'Inventario',
            id: 'Inventaris',
            ja: '在庫',
            zh: '库存',
            ko: '재고',
            hi: 'सूची',
            ar: 'المخزون'
        },
        path: '/inv/ICInventories',
        icon: icon_inventory,
        visible: {
            whenUserScreen: 'ICInventories',
            whenSession: {
                entity_type: { type: '!=', value: 'Customer' }
            }
        }
    },
    {
        text: {
            vi: 'Kho hàng',
            en: 'Warehouse',
            fr: 'Entrepôt',
            es: 'Almacén',
            id: 'Gudang',
            ja: '倉庫',
            zh: '仓库',
            ko: '창고',
            hi: 'गोदाम',
            ar: 'المستودع'
        },
        icon: icon_inventory,
        items: [
            {
                text: {
                    vi: 'Xuất Kho',
                    en: 'Issue',
                    fr: 'Sortie stock',
                    es: 'Salida inventario',
                    id: 'Pengeluaran stok',
                    ja: '在庫出庫',
                    zh: '库存出库',
                    ko: '재고 출고',
                    hi: 'इन्वेंट्री निर्गम',
                    ar: 'إصدار المخزون'
                },
                path: '/inv/ICIssues',
                visible: {
                    whenUserScreen: 'ICIssues'
                },
                navBadge: {
                    module: 'inv',
                    table: 'ICIssue',
                    searchConditions: {
                        issue_status: ['Release', 'Open'],
                        processable_qty: { type: '>', value: 0 }
                    }
                }
            },
            {
                text: {
                    vi: 'Nhập Kho',
                    en: 'Receipt',
                    fr: 'Entrée stock',
                    es: 'Entrada inventario',
                    id: 'Penerimaan stok',
                    ja: '在庫入庫',
                    zh: '库存入库',
                    ko: '재고 입고',
                    hi: 'इन्वेंट्री रसीद',
                    ar: 'استلام المخزون'
                },
                path: '/inv/ICReceipts',
                visible: {
                    whenUserScreen: 'ICReceipts'
                },
                navBadge: {
                    module: 'inv',
                    table: 'ICReceipt',
                    searchConditions: {
                        receipt_status: ['Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Chuyển Kho',
                    en: 'Transfer',
                    fr: 'Transfert stock',
                    es: 'Transferencia inventario',
                    id: 'Transfer stok',
                    ja: '在庫振替',
                    zh: '库存转移',
                    ko: '재고 이체',
                    hi: 'इन्वेंट्री स्थानांतरण',
                    ar: 'نقل المخزون'
                },
                path: '/inv/ICTransfers',
                visible: {
                    whenUserScreen: 'ICTransfers'
                },
                navBadge: {
                    module: 'inv',
                    table: 'ICTransfer',
                    searchConditions: {
                        transfer_status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Luân chuyển',
                    en: 'Transfer Demand',
                    fr: 'Demande transfert',
                    es: 'Demanda transferencia',
                    id: 'Permintaan transfer',
                    ja: '振替需要',
                    zh: '调拨需求',
                    ko: '이체 수요',
                    hi: 'ट्रांसफर मांग',
                    ar: 'طلب النقل'
                },
                path: '/spc/SPCDemandTransfers',
                visible: {
                    whenUserScreen: 'SPCDemandTransfers'
                },
                navBadge: {
                    module: 'spc',
                    table: 'SPCDemandBatch',
                    searchConditions: {
                        batch_status: 'Calculated',
                        action_type: 'Transfer'
                    }
                }
            },
            {
                text: {
                    vi: 'Điều Chỉnh',
                    en: 'Adjustment',
                    fr: 'Ajustement stock',
                    es: 'Ajuste inventario',
                    id: 'Penyesuaian stok',
                    ja: '在庫調整',
                    zh: '库存调整',
                    ko: '재고 조정',
                    hi: 'इन्वेंट्री समायोजन',
                    ar: 'تعديل المخزون'
                },
                path: '/inv/ICAdjusts',
                visible: {
                    whenUserScreen: 'ICAdjusts'
                },
                navBadge: {
                    module: 'inv',
                    table: 'ICAdjust',
                    searchConditions: {
                        adjust_status: 'New'
                    }
                }
            },
            {
                text: {
                    vi: 'Kiểm Kho',
                    en: 'Counting',
                    fr: 'Comptage stock',
                    es: 'Conteo inventario',
                    id: 'Penghitungan stok',
                    ja: '棚卸',
                    zh: '盘点',
                    ko: '재고 집계',
                    hi: 'इन्वेंट्री गणना',
                    ar: 'جرد المخزون'
                },
                path: '/inv/ICCountings',
                visible: {
                    whenUserScreen: 'ICCountings'
                },
                navBadge: {
                    module: 'inv',
                    table: 'ICCounting',
                    searchConditions: {
                        counting_status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Vị trí kho',
                    en: 'Locations',
                    fr: 'Emplacements',
                    es: 'Ubicaciones',
                    id: 'Lokasi',
                    ja: 'ロケーション',
                    zh: '库位',
                    ko: '위치',
                    hi: 'स्थान',
                    ar: 'المواقع'
                },
                path: '/inv/ICLocations',
                visible: {
                    whenUserScreen: 'ICLocations'
                }
            },
            {
                text: {
                    vi: 'Kiểm kê vị trí',
                    en: 'Location Audit',
                    fr: 'Audit emplacement',
                    es: 'Auditoría ubicación',
                    id: 'Audit lokasi',
                    ja: 'ロケーション監査',
                    zh: '库位审计',
                    ko: '위치 감사',
                    hi: 'स्थान ऑडिट',
                    ar: 'تدقيق الموقع'
                },
                path: '/inv/ICLocationAudits',
                visible: {
                    whenUserScreen: 'ICLocationAudits'
                },
                navBadge: { module: 'inv', table: 'ICStockAudit', searchConditions: { audit_status: 'New', audit_type: 'Location' } }
            },
            {
                text: {
                    vi: 'Kiểm kê lô hàng',
                    en: 'Lot Audit',
                    fr: 'Audit lot',
                    es: 'Auditoría lote',
                    id: 'Audit lot',
                    ja: 'ロット監査',
                    zh: '批次审计',
                    ko: '로트 감사',
                    hi: 'लॉट ऑडिट',
                    ar: 'تدقيق الدفعة'
                },
                path: '/inv/ICLotAudits',
                visible: {
                    whenUserScreen: 'ICLotAudits'
                },
                navBadge: { module: 'inv', table: 'ICStockAudit', searchConditions: { audit_status: 'New', audit_type: 'Lot' } }
            },
            {
                text: {
                    vi: 'Kiểm kê serial',
                    en: 'Serial Audit',
                    fr: 'Audit série',
                    es: 'Auditoría serial',
                    id: 'Audit serial',
                    ja: 'シリアル監査',
                    zh: '序列号审计',
                    ko: '시리얼 감사',
                    hi: 'सीरियल ऑडिट',
                    ar: 'تدقيق الرقم التسلسلي'
                },
                path: '/inv/ICSerialAudits',
                visible: {
                    whenUserScreen: 'ICSerialAudits'
                },
                navBadge: { module: 'inv', table: 'ICStockAudit', searchConditions: { audit_status: 'New', audit_type: 'Serial' } }
            },
            {
                text: {
                    vi: 'Nhập xuất tồn',
                    en: 'Report',
                    fr: 'Rapport stock',
                    es: 'Informe inventario',
                    id: 'Laporan stok',
                    ja: '在庫レポート',
                    zh: '库存报告',
                    ko: '재고 보고서',
                    hi: 'इन्वेंट्री रिपोर्ट',
                    ar: 'تقرير المخزون'
                },
                path: '/inv/ICMonthlyReports',
                visible: {
                    whenUserScreen: 'ICMonthlyReports'
                }
            },
            {
                text: {
                    vi: 'Giá vốn',
                    en: 'Inventory Valuation',
                    fr: 'Valorisation stock',
                    es: 'Valoración inventario',
                    id: 'Penilaian stok',
                    ja: '在庫評価',
                    zh: '库存估价',
                    ko: '재고 평가',
                    hi: 'इन्वेंट्री मूल्यांकन',
                    ar: 'تقييم المخزون'
                },
                path: '/inv/ICValuations',
                visible: {
                    whenUserScreen: 'ICValuations'
                }
            },
            {
                text: {
                    vi: 'Lắp ráp',
                    en: 'Assembly',
                    fr: 'Assemblage',
                    es: 'Ensamblaje',
                    id: 'Perakitan',
                    ja: '組立',
                    zh: '组装',
                    ko: '조립',
                    hi: 'असेंबली',
                    ar: 'تجميع'
                },
                path: '/inv/ICAssemblyOrders',
                visible: {
                    whenUserScreen: 'ICAssemblyOrders'
                },
                navBadge: {
                    module: 'inv',
                    table: 'ICAssemblyOrder',
                    searchConditions: {
                        status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Phân rã',
                    en: 'Disassembly',
                    fr: 'Démontage',
                    es: 'Desmontaje',
                    id: 'Pembongkaran',
                    ja: '分解',
                    zh: '拆卸',
                    ko: '분해',
                    hi: 'डिसअसेंबली',
                    ar: 'تفكيك'
                },
                path: '/inv/ICDeassemblyOrders',
                visible: {
                    whenUserScreen: 'ICDeassemblyOrders'
                },
                navBadge: {
                    module: 'inv',
                    table: 'ICDeassemblyOrder',
                    searchConditions: {
                        status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Số Serial',
                    en: 'Serials',
                    fr: 'Numéros série',
                    es: 'Seriales',
                    id: 'Serial',
                    ja: 'シリアル',
                    zh: '序列号',
                    ko: '시리얼',
                    hi: 'सीरियल',
                    ar: 'الأرقام التسلسلية'
                },
                path: '/inv/ICInventorySerials',
                visible: {
                    whenUserScreen: 'ICInventorySerials',
                    whenSession: {
                        entity_type: { type: '!=', value: 'Customer' }
                    }
                }
            },
            {
                text: {
                    vi: 'Mã lô',
                    en: 'Lot Code',
                    fr: 'Code lot',
                    es: 'Código lote',
                    id: 'Kode lot',
                    ja: 'ロットコード',
                    zh: '批次码',
                    ko: '로트 코드',
                    hi: 'लॉट कोड',
                    ar: 'رمز الدفعة'
                },
                path: '/inv/ICInventoryLots',
                visible: {
                    whenUserScreen: 'ICInventoryLots',
                    whenSession: {
                        entity_type: { type: '!=', value: 'Customer' }
                    }
                }
            }
        ]
    },
    {
        text: {
            vi: 'Mua Hàng',
            en: 'Purchase',
            fr: 'Achat',
            es: 'Compra',
            id: 'Pembelian',
            ja: '仕入',
            zh: '采购',
            ko: '구매',
            hi: 'खरीद',
            ar: 'شراء'
        },
        icon: icon_purchase,
        items: [
            {
                text: {
                    vi: 'Nhu cầu',
                    en: 'Purchase Demand',
                    fr: 'Demande achat',
                    es: 'Demanda compra',
                    id: 'Permintaan pembelian',
                    ja: '購入需要',
                    zh: '采购需求',
                    ko: '구매 수요',
                    hi: 'खरीद मांग',
                    ar: 'طلب الشراء'
                },
                path: '/spc/SPCDemandPurchases',
                visible: {
                    whenUserScreen: 'SPCDemandPurchases'
                },
                navBadge: {
                    module: 'spc',
                    table: 'SPCDemandBatch',
                    searchConditions: {
                        batch_status: 'Calculated',
                        action_type: 'Purchase'
                    }
                }
            },
            {
                text: {
                    vi: 'Đề nghị',
                    en: 'Purchase Request',
                    fr: "Demande d'achat",
                    es: 'Solicitud de compra',
                    id: 'Permintaan pembelian',
                    ja: '購買依頼',
                    zh: '采购申请',
                    ko: '구매 요청',
                    hi: 'खरीद अनुरोध',
                    ar: 'طلب شراء'
                },
                path: '/ap/APRequests',
                visible: {
                    whenUserScreen: 'APRequests'
                },
                navBadge: {
                    module: 'ap',
                    table: 'APRequest',
                    searchConditions: {
                        request_status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Báo giá',
                    en: 'Quotations',
                    fr: 'Devis fournisseurs',
                    es: 'Cotizaciones proveedor',
                    id: 'Penawaran Vendor',
                    ja: '仕入先見積',
                    zh: '供应商报价',
                    ko: '공급사 견적',
                    hi: 'विक्रेता उद्धरण',
                    ar: 'عروض الموردين'
                },
                path: '/ap/APQuotations',
                visible: {
                    whenUserScreen: 'APQuotations'
                }
            },
            {
                text: {
                    vi: 'Mua hàng',
                    en: 'Purchase Order',
                    fr: 'Bon de commande',
                    es: 'Orden de compra',
                    id: 'Pesanan pembelian',
                    ja: '発注書',
                    zh: '采购订单',
                    ko: '구매 주문',
                    hi: 'खरीद आदेश',
                    ar: 'أمر الشراء'
                },
                path: '/ap/APOrders',
                visible: {
                    whenUserScreen: 'APOrders'
                },
                navBadge: {
                    module: 'ap',
                    table: 'APOrder',
                    searchConditions: {
                        order_status: ['Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Nhận hàng',
                    en: 'Purchase Receive',
                    fr: 'Réception achat',
                    es: 'Recepción compra',
                    id: 'Penerimaan pembelian',
                    ja: '仕入受入',
                    zh: '采购收货',
                    ko: '구매 수령',
                    hi: 'खरीद प्राप्ति',
                    ar: 'استلام الشراء'
                },
                path: '/ap/APReceives',
                visible: {
                    whenUserScreen: 'APReceives'
                },
                navBadge: {
                    module: 'ap',
                    table: 'APReceive',
                    searchConditions: {
                        shipment_status: ['Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Trả hàng',
                    en: 'Purchase Return',
                    fr: 'Retour achat',
                    es: 'Devolución compra',
                    id: 'Retur pembelian',
                    ja: '仕入返品',
                    zh: '采购退货',
                    ko: '구매 반품',
                    hi: 'खरीद वापसी',
                    ar: 'إرجاع الشراء'
                },
                path: '/ap/APReturns',
                visible: {
                    whenUserScreen: 'APReturns'
                },
                navBadge: {
                    module: 'ap',
                    table: 'APReturn',
                    searchConditions: {
                        shipment_status: ['Release', 'Open']
                    }
                }
            },
            // {
            //     text: {
            //         vi: 'Hóa đơn',
            //         en: 'Purchase Invoice',
            //         fr: 'Facture achat',
            //         es: 'Factura compra',
            //         id: 'Faktur pembelian',
            //         ja: '仕入請求書',
            //         zh: '采购发票',
            //         ko: '구매 송장',
            //         hi: 'खरीद चालान',
            //         ar: 'فاتورة الشراء'
            //     },
            //     path: '/ap/APInvoices',
            //     visible: {
            //         whenUserScreen: 'APInvoices'
            //     }
            // },
            {
                text: {
                    vi: 'Chi phí mua hàng',
                    en: 'Purchase LandedCosts',
                    fr: 'Coûts achat',
                    es: 'Costos compra',
                    id: 'Biaya pembelian',
                    ja: '仕入諸経費',
                    zh: '采购到岸成本',
                    ko: '구매 비용',
                    hi: 'खरीद लैंडेड कॉस्ट',
                    ar: 'تكاليف الشراء'
                },
                path: '/exp/EXPAllocateAPs',
                visible: withoutAccountingMode({
                    whenUserScreen: 'EXPAllocateAPs'
                }),
                navBadge: {
                    module: 'exp',
                    table: 'EXPAllocateAP',
                    searchConditions: {
                        allocate_status: 'New'
                    }
                }
            },
            {
                text: {
                    vi: 'Chi phí nhập khẩu',
                    en: 'Import Duties',
                    fr: 'Droits importation',
                    es: 'Derechos importación',
                    id: 'Bea masuk',
                    ja: '輸入関税',
                    zh: '进口关税',
                    ko: '수입 관세',
                    hi: 'आयात शुल्क',
                    ar: 'الرسوم الجمركية'
                },
                path: '/ap/APImportCosts',
                visible: withoutAccountingMode({
                    whenUserScreen: 'APImportCosts'
                }),
                navBadge: {
                    module: 'ap',
                    table: 'APImportCost',
                    searchConditions: {
                        import_cost_status: ['New', 'Release', 'Open']
                    }
                }
            },
            // {
            //     text: {
            //         vi: 'KM bậc thang NCC',
            //         en: 'Vendor Tier Promotions',
            //         fr: 'Promotions par paliers',
            //         es: 'Promociones por niveles',
            //         id: 'Promosi Tier Vendor',
            //         ja: '仕入先段階割引',
            //         zh: '供应商阶梯促销',
            //         ko: '공급사 단계 프로모션',
            //         hi: 'विक्रेता स्तर प्रचार',
            //         ar: 'عروض المستويات'
            //     },
            //     path: '/ap/APVendorPromotions',
            //     visible: {
            //         whenUserScreen: 'APVendorPromotions'
            //     }
            // }
        ]
    },
    {
        text: {
            vi: 'Cung ứng',
            en: 'Supplychain',
            fr: 'Chaîne approvisionnement',
            es: 'Cadena suministro',
            id: 'Rantai pasokan',
            ja: 'サプライチェーン',
            zh: '供应链',
            ko: '공급망',
            hi: 'आपूर्ति श्रृंखला',
            ar: 'سلسلة التوريد'
        },
        icon: icon_supplychain,
        visible: {
            whenUser: {
                view_Module_SPC: 1
            },
            whenSys: {
                use_Module_IC: 1,
                use_Module_SPC: 1,
                use_Item_Good: 1,
            },

            when: {
                gr1: {
                    whenSys: {
                        store_qty: { type: '<', value: 2 }
                    }
                },
                gr2: {
                    whenSession: {
                        store_code: ['ALL_STORES']
                    }
                }
            },
            whenType: 'OR'
        },
        distinctable: false,
        items: [
            {
                text: {
                    vi: 'Kế hoạch cung-cầu',
                    en: 'Demand Planning',
                    fr: 'Planification besoins',
                    es: 'Planificación demanda',
                    id: 'Perencanaan kebutuhan',
                    ja: '需給計画',
                    zh: '供需计划',
                    ko: '수급 계획',
                    hi: 'मांग योजना',
                    ar: 'تخطيط الطلب'
                },
                path: '/spc/SPCDemandPlannings',
                visible: {
                    whenUserScreen: 'SPCDemandPlannings'
                },
                navBadge: {
                    module: 'spc',
                    table: 'SPCDemandBatch',
                    searchConditions: {
                        batch_status: 'Calculated'
                    }
                }
            },
            {
                text: {
                    vi: 'Quy tắc chuyển kho',
                    en: 'Stock Transfer Rules',
                    fr: 'Règles transfert stock',
                    es: 'Reglas transferencia stock',
                    id: 'Aturan transfer stok',
                    ja: '在庫振替ルール',
                    zh: '库存转移规则',
                    ko: '재고 이체 규칙',
                    hi: 'स्टॉक ट्रांसफर नियम',
                    ar: 'قواعد نقل المخزون'
                },
                path: '/spc/SPCSourcingPolicies',
                visible: {
                    whenUserScreen: 'SPCSourcingPolicies'
                }
            },
            {
                text: {
                    vi: 'Quy tắc mua hàng',
                    en: 'Purchase Rules',
                    fr: "Règles d'achat",
                    es: 'Reglas de compra',
                    id: 'Aturan pembelian',
                    ja: '購入ルール',
                    zh: '采购规则',
                    ko: '구매 규칙',
                    hi: 'खरीद नियम',
                    ar: 'قواعد الشراء'
                },
                path: '/spc/SPCPurchaseRules',
                visible: {
                    whenUserScreens: ['SPCPurchaseByICRules', 'SPCPurchaseByARRules']
                }
            },
            {
                text: {
                    vi: 'Luân chuyển kho',
                    en: 'Transfer Demand',
                    fr: 'Demande transfert',
                    es: 'Demanda transferencia',
                    id: 'Permintaan transfer',
                    ja: '振替需要',
                    zh: '转移需求',
                    ko: '이체 수요',
                    hi: 'ट्रांसफर मांग',
                    ar: 'طلب التحويل'
                },
                path: '/spc/SPCTransferStatuses',
                visible: {
                    whenUserScreen: 'SPCTransferStatuses'
                },
                navBadge: {
                    module: 'spc',
                    table: 'SPCSourcingPolicyItem',
                    searchConditions: {
                        rule_status: 'Close',
                        replenish_status: ['MinStock', 'Low']
                    }
                }
            },
            {
                text: {
                    vi: 'Mua bổ sung',
                    en: 'Purchase Status',
                    fr: 'Statut achat',
                    es: 'Estado compra',
                    id: 'Status pembelian',
                    ja: '購入状況',
                    zh: '采购状态',
                    ko: '구매 상태',
                    hi: 'खरीद स्थिति',
                    ar: 'حالة الشراء'
                },
                path: '/spc/SPCPurchaseStatuses',
                visible: {
                    whenUserScreens: ['SPCPurchaseByICStatuses', 'SPCPurchaseByARStatuses']
                },
                navBadge: {
                    module: 'spc',
                    table: 'SPCPurchaseByICRuleItem',
                    searchConditions: {
                        rule_status: 'Close',
                        require_qty: { type: '>', value: 0 }
                    }
                }
            }
        ]
    },
    {
        text: {
            vi: 'Sản xuất',
            en: 'Manufacturing ',
            fr: 'Manufacturing',
            es: 'Manufacturing',
            id: 'Manufacturing',
            ja: 'Manufacturing',
            zh: 'Manufacturing',
            ko: 'Manufacturing',
            hi: 'Manufacturing',
            ar: 'Manufacturing'
        },
        visible: {
            whenSys: {
                use_Module_MF: 1
            }
        },
        icon: icon_procedure,
        visible: {
            when: {
                gr1: {
                    whenSys: {
                        store_qty: { type: '<', value: 2 }
                    }
                },
                gr2: {
                    whenSession: {
                        store_code: ['ALL_STORES']
                    }
                }
            },
            whenType: 'OR'
        },
        items: [
            {
                text: {
                    vi: 'Phân xưởng',
                    en: 'Workshop',
                    fr: 'Atelier',
                    es: 'Taller',
                    id: 'Bengkel',
                    ja: '工場',
                    zh: '车间',
                    ko: '작업장',
                    hi: 'कार्यशाला',
                    ar: 'الورشة'
                },
                path: '/mf/MFAndonBoard',
                visible: {
                    whenUserScreen: 'MFWorkTickets'
                }
            },
            {
                text: {
                    vi: 'Phiếu giao việc',
                    en: 'Work Ticket',
                    fr: 'Bon travail',
                    es: 'Ticket trabajo',
                    id: 'Tiket kerja',
                    ja: '作業票',
                    zh: '工单',
                    ko: '작업 티켓',
                    hi: 'कार्य टिकट',
                    ar: 'تذكرة العمل'
                },
                path: '/mf/MFWorkTickets',
                visible: {
                    whenUserScreen: 'MFWorkTickets'
                }
            },
            {
                text: {
                    vi: 'Xuất nguyên liệu',
                    en: 'Material Issue',
                    fr: 'Sortie matière',
                    es: 'Salida material',
                    id: 'Pengeluaran bahan',
                    ja: '材料出庫',
                    zh: '材料发出',
                    ko: '자재 출고',
                    hi: 'सामग्री निर्गम',
                    ar: 'إصدار المواد'
                },
                path: '/mf/MFMaterialIssues',
                visible: {
                    whenUserScreen: 'MFMaterialIssues'
                },
                navBadge: { module: 'mf', table: 'MFMaterialIssue', searchConditions: { status: ['Release', 'Open'] } }
            },
            {
                text: {
                    vi: 'Sửa chữa hàng hỏng',
                    en: 'Rework',
                    fr: 'Reprise',
                    es: 'Reproceso',
                    id: 'Rework',
                    ja: '手直し',
                    zh: '返修',
                    ko: '재작업',
                    hi: 'रीवर्क',
                    ar: 'الإصلاح'
                },
                path: '/mf/MFReworkTickets',
                visible: {
                    whenUserScreen: 'MFReworkTickets'
                },
                navBadge: { module: 'mf', table: 'MFReworkTicket', searchConditions: { status: ['New', 'Open'] } }
            },
            {
                text: {
                    vi: 'Giá thành tạm tính',
                    en: 'Estimated Costing',
                    fr: 'Coût estimé',
                    es: 'Costo estimado',
                    id: 'Biaya estimasi',
                    ja: '見積原価',
                    zh: '暂估成本',
                    ko: '추정 원가',
                    hi: 'अनुमानित लागत',
                    ar: 'التكلفة التقديرية'
                },
                path: '/mf/MFCostings',
                visible: {
                    whenUserScreen: 'MFCostings'
                }
            },
            {
                text: {
                    vi: 'Nhật ký nhân lực',
                    en: 'Workforce log',
                    fr: 'Journal des effectifs',
                    es: 'Registro de personal',
                    id: 'Log tenaga kerja',
                    ja: '人員記録',
                    zh: '人力日志',
                    ko: '인력 일지',
                    hi: 'कार्यबल लॉग',
                    ar: 'سجل القوى العاملة'
                },
                path: '/mf/MFShiftRosters',
                visible: {
                    whenUserScreen: 'MFShiftRosters'
                }
            },
            {
                text: {
                    vi: 'Chấm công hộ',
                    en: 'Proxy attendance',
                    fr: 'Pointage pour autrui',
                    es: 'Registro por otros',
                    id: 'Absensi mewakili',
                    ja: '代理打刻',
                    zh: '代打卡',
                    ko: '대리 출퇴근',
                    hi: 'प्रॉक्सी उपस्थिति',
                    ar: 'الحضور بالنيابة'
                },
                path: '/timesheet/RollCalls?group_type=Workshop',
                visible: {
                    whenUserScreen: 'RollCalls'
                }
            },
            {
                text: {
                    vi: 'Bảng công xưởng',
                    en: 'Labor Sheet',
                    fr: 'Feuille main-d œuvre',
                    es: 'Hoja mano de obra',
                    id: 'Lembar kerja',
                    ja: '労務表',
                    zh: '工时表',
                    ko: '근태표',
                    hi: 'श्रम पत्रक',
                    ar: 'كشف العمالة'
                },
                path: '/mf/MFLaborSheets',
                visible: {
                    whenUserScreen: 'MFLaborSheets'
                }
            },
            {
                text: {
                    vi: 'Chi phí sản xuất',
                    en: 'Production Costs',
                    fr: 'Coûts production',
                    es: 'Costos producción',
                    id: 'Biaya produksi',
                    ja: '製造費用',
                    zh: '生产费用',
                    ko: '생산 비용',
                    hi: 'उत्पादन लागत',
                    ar: 'تكاليف الإنتاج'
                },
                path: '/mf/MFCostConfigs',
                visible: {
                    whenUserScreen: 'MFCostConfigs'
                }
            },
            // {
            //     text: {
            //         vi: 'Sản lượng',
            //         en: 'Production Output',
            //         fr: 'Production réalisée',
            //         es: 'Producción registrada',
            //         id: 'Hasil produksi',
            //         ja: '生産実績',
            //         zh: '生产产量',
            //         ko: '생산 실적',
            //         hi: 'उत्पादन मात्रा',
            //         ar: 'إدخال الإنتاج'
            //     },
            //     path: '/mf/MFWorkTicketActivity',
            //     visible: {
            //         whenUserScreen: 'MFWorkTickets'
            //     }
            // },
            // {
            //     text: {
            //         vi: 'Luân chuyển',
            //         en: 'Work Move',
            //         fr: 'Mouvement travail',
            //         es: 'Movimiento trabajo',
            //         id: 'Perpindahan kerja',
            //         ja: '作業移動',
            //         zh: '工作移动',
            //         ko: '작업 이동',
            //         hi: 'कार्य स्थानांतरण',
            //         ar: 'نقل العمل'
            //     },
            //     path: '/mf/MFWorkMoves',
            //     visible: {
            //         whenUserScreen: 'MFWorkMoves'
            //     }
            // },
            // {
            //     text: {
            //         vi: 'Nhập thành phẩm',
            //         en: 'Finished goods',
            //         fr: 'Produits finis',
            //         es: 'Productos terminados',
            //         id: 'Barang jadi',
            //         ja: '完成品入庫',
            //         zh: '成品入库',
            //         ko: '완제품 입고',
            //         hi: 'तैयार माल',
            //         ar: 'استلام البضائع الجاهزة'
            //     },
            //     path: '/mf/MFWorkFinishs',
            //     visible: {
            //         whenUserScreen: 'MFWorkFinishs'
            //     }
            // },
            // {
            //     text: {
            //         vi: 'Nhập bán thành phẩm',
            //         en: 'Semi-finished',
            //         fr: 'Produits semi-finis',
            //         es: 'Semielaborados',
            //         id: 'Barang setengah jadi',
            //         ja: '半製品入庫',
            //         zh: '半成品入库',
            //         ko: '반제품 입고',
            //         hi: 'अर्ध-तैयार',
            //         ar: 'استلام نصف المصنّع'
            //     },
            //     path: '/mf/MFWorkSemiFinishs',
            //     visible: {
            //         whenUserScreen: 'MFWorkSemiFinishs'
            //     }
            // },
            {
                text: {
                    vi: 'Lệnh sản xuất',
                    en: 'Production Order',
                    fr: 'Ordre de production',
                    es: 'Orden de producción',
                    id: 'Perintah produksi',
                    ja: '製造指示',
                    zh: '生产订单',
                    ko: '생산 지시',
                    hi: 'उत्पादन आदेश',
                    ar: 'أمر الإنتاج'
                },
                path: '/mf/MFMakeOrders',
                visible: {
                    whenUserScreen: 'MFMakeOrders'
                },
                navBadge: { module: 'mf', table: 'MFMakeOrder', searchConditions: { status: ['New', 'Release', 'Open'] } }
            },
            {
                text: {
                    vi: 'Kế hoạch sản xuất',
                    // en: 'Master Production Schedule'
                    en: 'Production Schedule'
                },
                path: '/mf/MFMPSs',
                visible: {
                    whenUserScreen: 'MFMPSs'
                },
                navBadge: { module: 'mf', table: 'MFMPS', searchConditions: { status: ['New', 'Release', 'Open'] } }
            },
            {
                text: {
                    vi: 'Định mức',
                    en: 'Bill of Material',
                    fr: 'Nomenclature',
                    es: 'Lista materiales',
                    id: 'Daftar bahan',
                    ja: '部品表',
                    zh: '物料清单',
                    ko: '자재 명세서',
                    hi: 'सामग्री सूची',
                    ar: 'قائمة المواد'
                },
                path: '/mf/MFBOMs',
                visible: {
                    whenUserScreen: 'MFBOMs'
                }
            }
        ]
    },
    {
        text: {
            vi: 'Sổ Quỹ',
            en: 'Cash Book',
            fr: 'Journal caisse',
            es: 'Libro caja',
            id: 'Buku kas',
            ja: '現金出納帳',
            zh: '现金日记账',
            ko: '현금 출납부',
            hi: 'नकद पुस्तिका',
            ar: 'دفتر النقدية'
        },
        icon: icon_cash,
        distinctable: false,
        // visible: {
        //     whenSys: {
        //         use_Module_CA: 1,
        //     },
        //     whenUser: {
        //         view_Module_CA: 1
        //     }
        // },
        items: [
            {
                text: {
                    vi: 'Đề nghị chi',
                    en: 'Cash Out Request',
                    fr: 'Demande décaissement',
                    es: 'Solicitud salida efectivo',
                    id: 'Permintaan kas keluar',
                    ja: '出金依頼',
                    zh: '付款请求',
                    ko: '출금 요청',
                    hi: 'नकद निकासी अनुरोध',
                    ar: 'طلب النقد الخارج'
                },
                path: '/ca/CAIssueRequests',
                // 24/10: Đề nghị thu/chi chỉ ở Vận hành cho mọi doanh nghiệp (Kế toán không tham gia vận hành).
                visible: { whenUserScreen: 'CAIssueRequests' },
                navBadge: {
                    module: 'ca',
                    table: 'CARequest',
                    searchConditions: {
                        type: 'Issue',
                        request_status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Đề nghị thu',
                    en: 'Cash In Request',
                    fr: 'Demande encaissement',
                    es: 'Solicitud entrada efectivo',
                    id: 'Permintaan kas masuk',
                    ja: '入金依頼',
                    zh: '收款请求',
                    ko: '입금 요청',
                    hi: 'नकद प्राप्ति अनुरोध',
                    ar: 'طلب النقد الداخل'
                },
                path: '/ca/CAReceiveRequests',
                // 24/10: Đề nghị thu/chi chỉ ở Vận hành cho mọi doanh nghiệp (Kế toán không tham gia vận hành).
                visible: { whenUserScreen: 'CAReceiveRequests' },
                navBadge: {
                    module: 'ca',
                    table: 'CARequest',
                    searchConditions: {
                        type: 'Receive',
                        request_status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Phiếu chi',
                    en: 'Cash Out',
                    fr: 'Décaissement',
                    es: 'Salida efectivo',
                    id: 'Kas keluar',
                    ja: '出金',
                    zh: '付款',
                    ko: '출금',
                    hi: 'नकद निकासी',
                    ar: 'النقد الخارج'
                },
                path: '/ca/CAIssues',
                visible: withoutAccountingMode({
                    whenUserScreen: 'CAIssues'
                }),
                navBadge: {
                    module: 'ca',
                    table: 'CAIssue',
                    searchConditions: {
                        issue_status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Phiếu thu',
                    en: 'Cash In',
                    fr: 'Encaissement',
                    es: 'Entrada efectivo',
                    id: 'Kas masuk',
                    ja: '入金',
                    zh: '收款',
                    ko: '입금',
                    hi: 'नकद प्राप्ति',
                    ar: 'النقد الداخل'
                },
                path: '/ca/CAReceives',
                visible: withoutAccountingMode({
                    whenUserScreen: 'CAReceives'
                }),
                navBadge: {
                    module: 'ca',
                    table: 'CAReceive',
                    searchConditions: {
                        receive_status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Chuyển tiền',
                    en: 'Cash Transfer',
                    fr: 'Transfert caisse',
                    es: 'Transferencia caja',
                    id: 'Transfer kas',
                    ja: '現金振替',
                    zh: '现金转账',
                    ko: '현금 이체',
                    hi: 'नकद हस्तांतरण',
                    ar: 'تحويل النقدية'
                },
                path: '/ca/CATransfers',
                visible: withoutAccountingMode({
                    whenUserScreen: 'CATransfers'
                }),
                navBadge: {
                    module: 'ca',
                    table: 'CATransfer',
                    searchConditions: {
                        mix_status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Điều Chỉnh',
                    en: 'Cash Adjustment',
                    fr: 'Ajustement caisse',
                    es: 'Ajuste caja',
                    id: 'Penyesuaian kas',
                    ja: '現金調整',
                    zh: '现金调整',
                    ko: '현금 조정',
                    hi: 'नकद समायोजन',
                    ar: 'تعديل النقدية'
                },
                path: '/ca/CAAdjusts',
                visible: withoutAccountingMode({
                    whenUserScreen: 'CAAdjusts'
                }),
                navBadge: {
                    module: 'ca',
                    table: 'CAAdjust',
                    searchConditions: {
                        adjust_status: 'New'
                    }
                }
            },
            {
                text: {
                    vi: 'Số dư',
                    en: 'Cash Balance',
                    fr: 'Solde caisse',
                    es: 'Saldo caja',
                    id: 'Saldo kas',
                    ja: '現金残高',
                    zh: '现金余额',
                    ko: '현금 잔액',
                    hi: 'नकद शेष',
                    ar: 'رصيد النقدية'
                },
                path: '/ca/CABalances',
                visible: withoutAccountingMode({
                    whenUserScreen: 'CABalances'
                })
            },
            {
                text: {
                    vi: 'Đối soát',
                    en: 'Reconciliation',
                    fr: 'Rapprochement bancaire',
                    es: 'Conciliación bancaria',
                    id: 'Rekonsiliasi bank',
                    ja: '銀行照合',
                    zh: '银行对账',
                    ko: '은행 대사',
                    hi: 'बैंक सामंजस्य',
                    ar: 'التسوية البنكية'
                },
                path: '/ca/CABankStatements',
                visible: withoutAccountingMode({
                    whenUserScreen: 'CABankStatements'
                }),
                navBadge: {
                    module: 'ca',
                    table: 'CABankStatement',
                    searchConditions: {
                        statement_status: ['New', 'Matching']
                    }
                }
            },
            {
                text: {
                    vi: 'Sổ quỹ',
                    en: 'Cash Book',
                    fr: 'Livre de caisse',
                    es: 'Libro de caja',
                    id: 'Buku Kas',
                    ja: '現金出納帳',
                    zh: '现金日记账',
                    ko: '현금출납장',
                    hi: 'नकद बही',
                    ar: 'دفتر النقدية'
                },
                path: '/ca/CACashBook',
                visible: withoutAccountingMode({
                    whenUserScreen: 'CACashBook'
                })
            },
            {
                text: {
                    vi: 'Dòng tiền',
                    en: 'Cash Flow',
                    fr: 'Rapport de flux de trésorerie',
                    es: 'Informe de flujo de caja',
                    id: 'Laporan Arus Kas',
                    ja: 'キャッシュフロー報告書',
                    zh: '现金流量报告',
                    ko: '현금흐름 보고서',
                    hi: 'नकदी प्रवाह रिपोर्ट',
                    ar: 'تقرير التدفق النقدي'
                },
                path: '/ca/CACashFlows',
                visible: withoutAccountingMode({
                    whenUserScreen: 'CACashFlows'
                })
            },
            {
                text: {
                    vi: 'Chốt quỹ POS',
                    en: 'POS Cash Settlement',
                    fr: 'Clôture caisse POS',
                    es: 'Liquidación caja POS',
                    id: 'Penyelesaian Kas POS',
                    ja: 'POSレジ締め',
                    zh: 'POS现金结算',
                    ko: 'POS 현금 정산',
                    hi: 'POS नकद निपटान',
                    ar: 'تسوية نقدية POS'
                },
                path: '/ca/POSCashSettlements',
                visible: {
                    whenUserScreen: 'POSCashSettlements'
                }
            },
            {
                text: {
                    vi: 'Đánh giá ngoại tệ',
                    en: 'FX Revaluation',
                    fr: 'Réévaluation devises',
                    es: 'Revaluación FX',
                    id: 'Revaluasi FX',
                    ja: '外貨再評価',
                    zh: '外币重估',
                    ko: 'FX 재평가',
                    hi: 'FX पुनर्मूल्यांकन',
                    ar: 'إعادة تقييم العملات'
                },
                path: '/gl/GLFXRevaluations',
                visible: withoutAccountingMode({
                    whenSys: { use_CA_ForeignCurrency: 1, use_CA_FXRevaluation: 1 },
                    whenUserScreen: 'GLFXRevaluations'
                }),
                navBadge: { module: 'gl', table: 'GLFXRevaluation', searchConditions: { revaluation_status: ['New', 'Release'] } }
            }
        ]
    },
    {
        text: {
            vi: 'Chi tiêu',
            en: 'Spending',
            fr: 'Dépenses',
            es: 'Gastos',
            id: 'Pengeluaran',
            ja: '支出',
            zh: '支出',
            ko: '지출',
            hi: 'खर्च',
            ar: 'الإنفاق'
        },
        icon: icon_expense,
        // distinctable: false,
        items: [
            {
                text: {
                    vi: 'Mua hàng',
                    en: 'Purchases',
                    fr: 'Achats',
                    es: 'Compras',
                    id: 'Pembelian',
                    ja: '仕入',
                    zh: '采购',
                    ko: '매입',
                    hi: 'खरीद',
                    ar: 'المشتريات'
                },
                path: '/exp/EXPPurchaseOrders',
                visible: withoutAccountingMode({
                    whenUserScreen: 'EXPPurchaseOrders'
                }),
                navBadge: {
                    module: 'exp',
                    table: 'EXPPurchaseOrder',
                    searchConditions: {
                        type: 'Purchase',
                        order_status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Nhập khẩu',
                    en: 'Imports',
                    fr: 'Importations',
                    es: 'Importaciones',
                    id: 'Impor',
                    ja: '輸入',
                    zh: '进口',
                    ko: '수입',
                    hi: 'आयात',
                    ar: 'الاستيراد'
                },
                path: '/exp/EXPImportDutyOrders',
                visible: withoutAccountingMode({
                    whenUserScreen: 'EXPImportDutyOrders'
                }),
                navBadge: {
                    module: 'exp',
                    table: 'EXPImportDutyOrder',
                    searchConditions: {
                        type: 'ImportDuty',
                        order_status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Chi phí',
                    en: 'Expenses',
                    fr: 'Charges',
                    es: 'Costos',
                    id: 'Biaya',
                    ja: '経費',
                    zh: '费用',
                    ko: '비용',
                    hi: 'व्यय',
                    ar: 'المصروفات'
                },
                path: '/exp/EXPGeneralOrders',
                // 24/10: người vào được chế độ Kế toán thì chứng từ chi phí theo người lập — có ERP (use_Module_AR) nhân viên lập ở Vận hành, không ERP kế toán lập ở Kế toán.
                visible: [...withoutAccountingMode({ whenUserScreen: 'EXPGeneralOrders' }), { whenUserScreen: 'EXPGeneralOrders', whenSys: { use_Module_AR: 1 } }],
                navBadge: {
                    module: 'exp',
                    table: 'EXPGeneralOrder',
                    searchConditions: {
                        type: 'General',
                        order_status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Bảng lương',
                    en: 'Payroll',
                    fr: 'Paie',
                    es: 'Nómina',
                    id: 'Penggajian',
                    ja: '給与',
                    zh: '工资单',
                    ko: '급여',
                    hi: 'वेतन',
                    ar: 'الرواتب'
                },
                path: '/exp/EXPPayrollOrders',
                visible: withoutAccountingMode({
                    whenUserScreen: 'EXPPayrollOrders'
                }),
                navBadge: {
                    module: 'exp',
                    table: 'EXPPayrollOrder',
                    searchConditions: {
                        type: 'Payroll',
                        order_status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Bảo hiểm',
                    en: 'Insurance',
                    fr: 'Assurance',
                    es: 'Seguros',
                    id: 'Asuransi',
                    ja: '保険',
                    zh: '保险',
                    ko: '보험',
                    hi: 'बीमा',
                    ar: 'التأمين'
                },
                path: '/exp/EXPInsuranceOrders',
                visible: withoutAccountingMode({
                    whenUserScreen: 'EXPInsuranceOrders'
                }),
                navBadge: {
                    module: 'exp',
                    table: 'EXPInsuranceOrder',
                    searchConditions: {
                        type: 'Insurance',
                        order_status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Nộp thuế, phí',
                    en: 'Taxes & Fees',
                    fr: 'Impôts et taxes',
                    es: 'Impuestos y tasas',
                    id: 'Pajak dan biaya',
                    ja: '税金・手数料',
                    zh: '税费',
                    ko: '세금 및 수수료',
                    hi: 'कर और शुल्क',
                    ar: 'الضرائب والرسوم'
                },
                path: '/exp/EXPTaxOrders',
                visible: withoutAccountingMode({
                    whenUserScreen: 'EXPTaxOrders'
                }),
                navBadge: {
                    module: 'exp',
                    table: 'EXPTaxOrder',
                    searchConditions: {
                        type: 'Tax',
                        order_status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Mua sắm Công Cụ',
                    en: 'Equipment Procurement',
                    fr: 'Acquisition équipement',
                    es: 'Adquisición equipo',
                    id: 'Pengadaan peralatan',
                    ja: '設備調達',
                    zh: '设备采购',
                    ko: '장비 조달',
                    hi: 'उपकरण खरीद',
                    ar: 'شراء المعدات'
                },
                path: '/exp/EXPEquipmentProcurementOrders',
                visible: withoutAccountingMode({
                    whenUserScreen: 'EXPEquipmentProcurementOrders'
                }),
                navBadge: {
                    module: 'exp',
                    table: 'EXPEquipmentProcurementOrder',
                    searchConditions: { type: 'EquipmentProcurement', order_status: ['Release', 'Open'] }
                }
            },
            {
                text: {
                    vi: 'Mua sắm tài sản',
                    en: 'Asset Procurement',
                    fr: 'Acquisition actifs',
                    es: 'Adquisición activos',
                    id: 'Pengadaan aset',
                    ja: '資産調達',
                    zh: '资产采购',
                    ko: '자산 조달',
                    hi: 'संपत्ति खरीद',
                    ar: 'شراء الأصول'
                },
                path: '/exp/EXPAssetProcurementOrders',
                visible: withoutAccountingMode({
                    whenUserScreen: 'EXPAssetProcurementOrders'
                }),
                navBadge: {
                    module: 'exp',
                    table: 'EXPAssetProcurementOrder',
                    searchConditions: { type: 'AssetProcurement', order_status: ['Release', 'Open'] }
                }
            },
            {
                text: {
                    vi: 'Trả hoa hồng',
                    en: 'Commission Disbursement',
                    fr: 'Versement commission',
                    es: 'Desembolso comisión',
                    id: 'Pencairan komisi',
                    ja: '手数料支払',
                    zh: '佣金支付',
                    ko: '수수료 지급',
                    hi: 'कमीशन संवितरण',
                    ar: 'صرف العمولة'
                },
                path: '/coms/CRMComsPayments',
                visible: {
                    whenUserScreen: 'CRMComsPayments'
                },
                navBadge: { module: 'coms', table: 'CRMComsPayment', searchConditions: { ca_request_status: ['New', 'Release', 'Open'] } }
            },
            {
                text: {
                    vi: 'Cước vận tải',
                    en: 'Logistic Fee',
                    fr: 'Frais logistique',
                    es: 'Tarifa logística',
                    id: 'Biaya logistik',
                    ja: '物流費',
                    zh: '物流费',
                    ko: '물류비',
                    hi: 'लॉजिस्टिक्स शुल्क',
                    ar: 'رسوم اللوجستيات'
                },
                path: '/exp/EXPLogisticOrders',
                visible: {
                    whenUserScreen: 'EXPLogisticOrders'
                },
                navBadge: { module: 'exp', table: 'EXPLogisticOrder', searchConditions: { type: 'Logistic', order_status: ['Release', 'Open'] } }
            },
            {
                text: {
                    vi: 'Phải trả khác',
                    en: 'Other Payables',
                    fr: 'Charges à payer',
                    es: 'Por pagar adicional',
                    id: 'Hutang tambahan',
                    ja: '未払費用',
                    zh: '其他应付',
                    ko: '기타 미지급',
                    hi: 'अतिरिक्त देय',
                    ar: 'دائنون إضافيون'
                },
                path: '/exp/EXPExtraPayableOrders',
                visible: withoutAccountingMode({
                    whenUserScreen: 'EXPExtraPayableOrders'
                }),
                navBadge: {
                    module: 'exp',
                    table: 'EXPExtraPayableOrder',
                    searchConditions: { type: 'ExtraPayable', order_status: ['Release', 'Open'] }
                }
            },
            {
                text: {
                    vi: 'Ngân sách chi phí',
                    en: 'Expense Budgets',
                    fr: 'Budgets des dépenses',
                    es: 'Presupuestos de gastos',
                    id: 'Anggaran biaya',
                    ja: '費用予算',
                    zh: '费用预算',
                    ko: '비용 예산',
                    hi: 'व्यय बजट',
                    ar: 'ميزانية المصروفات'
                },
                path: '/exp/EXPBudgets',
                // 24/10: người vào được chế độ Kế toán thì chứng từ chi phí theo người lập — có ERP (use_Module_AR) nhân viên lập ở Vận hành, không ERP kế toán lập ở Kế toán.
                visible: [...withoutAccountingMode({ whenUserScreen: 'EXPBudgets' }), { whenUserScreen: 'EXPBudgets', whenSys: { use_Module_AR: 1 } }],
                navBadge: { module: 'exp', table: 'EXPBudget', searchConditions: { budget_status: ['New', 'Release'] } }
            },
            {
                text: {
                    vi: 'So sánh ngân sách',
                    en: 'Budget Comparison',
                    fr: 'Comparaison budgétaire',
                    es: 'Comparación presupuestaria',
                    id: 'Perbandingan anggaran',
                    ja: '予算比較',
                    zh: '预算对比',
                    ko: '예산 비교',
                    hi: 'बजट तुलना',
                    ar: 'مقارنة الميزانية'
                },
                path: '/exp/EXPBudgetComparisons',
                // 24/10: người vào được chế độ Kế toán thì chứng từ chi phí theo người lập — có ERP (use_Module_AR) nhân viên lập ở Vận hành, không ERP kế toán lập ở Kế toán.
                visible: [...withoutAccountingMode({ whenUserScreen: 'EXPBudgetComparisons' }), { whenUserScreen: 'EXPBudgetComparisons', whenSys: { use_Module_AR: 1 } }]
            }
        ]
    },
    {
        // Có AR (ERP): Thu khác nằm trong tab Phải trả như cũ. Không có AR: dùng tab Phải thu riêng (nhóm dưới).
        text: {
            vi: 'Phải Thu',
            en: 'Receivable',
            fr: 'À recevoir',
            es: 'Por recibir',
            id: 'Piutang',
            ja: '未納',
            zh: '未交付',
            ko: '미납',
            hi: 'प्राप्य',
            ar: 'مستحق'
        },
        icon: icon_procedure,
        visible: { whenSys: { use_Module_AR: 1 } },
        // distinctable: false,
        items: [
            {
                text: {
                    vi: 'Thu khác',
                    en: 'Receivable',
                    fr: 'À recevoir',
                    es: 'Por recibir',
                    id: 'Piutang',
                    ja: '未納',
                    zh: '未交付',
                    ko: '미납',
                    hi: 'प्राप्य',
                    ar: 'مستحق'
                },
                path: '/exr/EXROrders',
                visible: withoutAccountingMode({
                    whenUserScreen: 'EXROrders'
                }),
                navBadge: {
                    module: 'exr',
                    table: 'EXROrder',
                    searchConditions: {
                        type: 'General',
                        order_status: ['New', 'Release', 'Open']
                    }
                }
            }
            // {
            //     text: {
            //         vi: 'Phải thu khác',
            //         en: 'Extra Receivable'
            //     },
            //     path: '/exr/EXROtherOrders',
            //     visible: {
            //         whenUserScreen: 'EXROtherOrders'
            //     }
            // }
        ]
    },
    {
        // Gói Kế toán (không có AR): tab Phải thu riêng (module exr). Đường dẫn /sale/ trỏ cùng trang với /exr/, /crm/, /tax/
        // để thanh điều hướng nhận đúng tab (kit nhận module theo tiền tố đường dẫn, không xét mục ẩn).
        module: 'exr',
        text: {
            vi: 'Phải thu',
            en: 'Receivables',
            fr: 'Clients',
            es: 'Por cobrar',
            id: 'Piutang',
            ja: '売掛',
            zh: '应收',
            ko: '미수',
            hi: 'प्राप्य',
            ar: 'المدينون'
        },
        icon: icon_procedure,
        visible: { whenSys: { use_Module_EXR: 1, use_Module_AR: { type: '!=', value: 1 } } },
        items: [
            {
                text: {
                    vi: 'Bán hàng',
                    en: 'Sales',
                    fr: 'Ventes',
                    es: 'Ventas',
                    id: 'Penjualan',
                    ja: '売上',
                    zh: '销售',
                    ko: '판매',
                    hi: 'बिक्री',
                    ar: 'المبيعات'
                },
                path: '/sale/EXROrders',
                visible: withoutAccountingMode({ whenUserScreen: 'EXROrders' }),
                navBadge: {
                    module: 'exr',
                    table: 'EXROrder',
                    searchConditions: {
                        type: 'General',
                        order_status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Phải thu khác',
                    en: 'Other receivables',
                    fr: 'Autres créances',
                    es: 'Otras cuentas por cobrar',
                    id: 'Piutang lain',
                    ja: 'その他未収金',
                    zh: '其他应收',
                    ko: '기타 미수금',
                    hi: 'अन्य प्राप्य',
                    ar: 'ذمم أخرى'
                },
                path: '/sale/EXROtherOrders',
                visible: withoutAccountingMode({ whenUserScreen: 'EXROtherOrders' }),
                navBadge: {
                    module: 'exr',
                    table: 'EXROtherOrder',
                    searchConditions: {
                        type: 'OtherReceivable',
                        order_status: ['New', 'Release', 'Open']
                    }
                }
            },
            {
                text: {
                    vi: 'Khách hàng',
                    en: 'Customers',
                    fr: 'Clients',
                    es: 'Clientes',
                    id: 'Pelanggan',
                    ja: '顧客',
                    zh: '客户',
                    ko: '고객',
                    hi: 'ग्राहक',
                    ar: 'العملاء'
                },
                path: '/sale/Customers',
                visible: { whenUserScreen: 'Customers' }
            }
        ]
    },
    {
        text: {
            vi: 'Tài sản',
            en: 'Asset',
            fr: 'Actif',
            es: 'Activo',
            id: 'Aset',
            ja: '資産',
            zh: '资产',
            ko: '자산',
            hi: 'संपत्ति',
            ar: 'الأصول'
        },
        icon: icon_inventory,
        visible: withoutAccountingMode({
            // Người vào được chế độ Kế toán: nhóm này chỉ hiện ở chế độ Kế toán.
            when: {
                gr1: {
                    whenSys: {
                        store_qty: { type: '<', value: 2 }
                    }
                },
                gr2: {
                    whenSession: {
                        store_code: ['ALL_STORES']
                    }
                }
            },
            whenType: 'OR'
        }),
        items: [
            {
                text: {
                    vi: 'Tài sản',
                    en: 'Asset Management',
                    fr: 'Gestion actifs',
                    es: 'Gestión activos',
                    id: 'Manajemen aset',
                    ja: '資産管理',
                    zh: '资产管理',
                    ko: '자산 관리',
                    hi: 'संपत्ति प्रबंधन',
                    ar: 'إدارة الأصول'
                },
                path: '/fa/FAAssets',
                visible: {
                    whenUserScreen: 'FAAssets'
                }
            },
            {
                text: {
                    vi: 'Ghi tăng',
                    en: 'Asset Register',
                    fr: 'Registre actifs',
                    es: 'Registro activos',
                    id: 'Daftar aset',
                    ja: '資産登録',
                    zh: '资产登记',
                    ko: '자산 등록',
                    hi: 'संपत्ति पंजीकरण',
                    ar: 'سجل الأصول'
                },
                path: '/fa/FAAssetRegisters',
                visible: {
                    whenUserScreen: 'FAAssetRegisters'
                },
                navBadge: { module: 'fa', table: 'FAAssetRegister', searchConditions: { status: 'New' } }
            },
            {
                text: {
                    vi: 'Nâng cấp',
                    en: 'Asset Upgrade',
                    fr: 'Mise à niveau actifs',
                    es: 'Mejora activos',
                    id: 'Upgrade aset',
                    ja: '資産アップグレード',
                    zh: '资产升级',
                    ko: '자산 업그레이드',
                    hi: 'संपत्ति अपग्रेड',
                    ar: 'ترقية الأصول'
                },
                path: '/fa/FAAssetAdjIncs',
                visible: {
                    whenUserScreen: 'FAAssetAdjIncs'
                },
                navBadge: { module: 'fa', table: 'FAAssetAdjInc', searchConditions: { status: 'New' } }
            },
            {
                text: {
                    vi: 'Định giá',
                    en: 'Asset Downgrade',
                    fr: 'Rétrogradation actifs',
                    es: 'Degradación activos',
                    id: 'Downgrade aset',
                    ja: '資産ダウングレード',
                    zh: '资产降级',
                    ko: '자산 다운그레이드',
                    hi: 'संपत्ति डाउनग्रेड',
                    ar: 'تخفيض الأصول'
                },
                path: '/fa/FAAssetAdjDecs',
                visible: {
                    whenUserScreen: 'FAAssetAdjDecs'
                },
                navBadge: { module: 'fa', table: 'FAAssetAdjDec', searchConditions: { status: 'New' } }
            },
            {
                text: {
                    vi: 'Ghi giảm',
                    en: 'Asset Disposal',
                    fr: 'Cession actifs',
                    es: 'Disposición activos',
                    id: 'Pelepasan aset',
                    ja: '資産除却',
                    zh: '资产处置',
                    ko: '자산 처분',
                    hi: 'संपत्ति निपटान',
                    ar: 'التخلص من الأصول'
                },
                path: '/fa/FAAssetDisposes',
                visible: {
                    whenUserScreen: 'FAAssetDisposes'
                },
                navBadge: { module: 'fa', table: 'FAAssetDispose', searchConditions: { status: 'New' } }
            },
            {
                text: {
                    vi: 'Khấu hao',
                    en: 'Asset Depreciation',
                    fr: 'Amortissement actifs',
                    es: 'Depreciación activos',
                    id: 'Penyusutan aset',
                    ja: '減価償却',
                    zh: '资产折旧',
                    ko: '자산 감가상각',
                    hi: 'संपत्ति मूल्यह्रास',
                    ar: 'إهلاك الأصول'
                },
                path: '/fa/FAAssetDepreciates',
                visible: {
                    whenUserScreen: 'FAAssetDepreciates'
                },
                navBadge: { module: 'fa', table: 'FAAssetDepreciate', searchConditions: { status: 'New', month_id_endMonth: '$currentMonthID' } }
            }
        ]
    },
    {
        text: {
            vi: 'Công cụ',
            en: 'Equipment',
            fr: 'Équipement',
            es: 'Equipo',
            id: 'Peralatan',
            ja: '設備',
            zh: '设备',
            ko: '장비',
            hi: 'उपकरण',
            ar: 'المعدات'
        },
        icon: icon_table,
        visible: withoutAccountingMode({
            // Người vào được chế độ Kế toán: nhóm này chỉ hiện ở chế độ Kế toán.
            when: {
                gr1: {
                    whenSys: {
                        store_qty: { type: '<', value: 2 }
                    }
                },
                gr2: {
                    whenSession: {
                        store_code: ['ALL_STORES']
                    }
                }
            },
            whenType: 'OR'
        }),
        items: [
            {
                text: {
                    vi: 'Công cụ dụng cụ',
                    en: 'Equipment',
                    fr: 'Équipement',
                    es: 'Equipo',
                    id: 'Peralatan',
                    ja: '設備',
                    zh: '设备',
                    ko: '장비',
                    hi: 'उपकरण',
                    ar: 'المعدات'
                },
                path: '/fa/FAEquipments',
                visible: {
                    whenUserScreen: 'FAEquipments'
                }
            },
            {
                text: {
                    vi: 'Ghi tăng CCDC',
                    en: 'Equipment Register',
                    fr: 'Registre équipement',
                    es: 'Registro equipo',
                    id: 'Daftar peralatan',
                    ja: '設備登録',
                    zh: '设备登记',
                    ko: '장비 등록',
                    hi: 'उपकरण पंजीकरण',
                    ar: 'سجل المعدات'
                },
                path: '/fa/FAEquipmentRegisters',
                visible: {
                    whenUserScreen: 'FAEquipmentRegisters'
                },
                navBadge: { module: 'fa', table: 'FAEquipmentRegister', searchConditions: { status: 'New' } }
            },
            {
                text: {
                    vi: 'Ghi giảm CCDC',
                    en: 'Equipment Disposal',
                    fr: 'Cession équipement',
                    es: 'Disposición equipo',
                    id: 'Pelepasan peralatan',
                    ja: '設備除却',
                    zh: '设备处置',
                    ko: '장비 처분',
                    hi: 'उपकरण निपटान',
                    ar: 'التخلص من المعدات'
                },
                path: '/fa/FAEquipmentDisposes',
                visible: {
                    whenUserScreen: 'FAEquipmentDisposes'
                },
                navBadge: { module: 'fa', table: 'FAEquipmentDispose', searchConditions: { status: 'New' } }
            },
            {
                text: {
                    vi: 'Phân bổ chi phí',
                    en: 'Equipment Depreciation',
                    fr: 'Amortissement équipement',
                    es: 'Depreciación equipo',
                    id: 'Penyusutan peralatan',
                    ja: '設備減価償却',
                    zh: '设备折旧',
                    ko: '장비 감가상각',
                    hi: 'उपकरण मूल्यह्रास',
                    ar: 'إهلاك المعدات'
                },
                path: '/fa/FAEquipmentDepreciates',
                visible: {
                    whenUserScreen: 'FAEquipmentDepreciates'
                },
                navBadge: { module: 'fa', table: 'FAEquipmentDepreciate', searchConditions: { status: 'New', month_id_endMonth: '$currentMonthID' } }
            }
        ]
    },
    {
        text: {
            vi: 'Giá thành',
            en: 'Costing',
            fr: 'Calcul coûts',
            es: 'Costeo',
            id: 'Perhitungan biaya',
            ja: '原価計算',
            zh: '成本计算',
            ko: '원가 계산',
            hi: 'लागत गणना',
            ar: 'التكلفة'
        },
        icon: icon_procedure,
        distinctable: false,
        visible: withoutAccountingMode({
            // Người vào được chế độ Kế toán: nhóm này chỉ hiện ở chế độ Kế toán.
            when: {
                gr1: {
                    whenSys: {
                        store_qty: { type: '<', value: 2 }
                    }
                },
                gr2: {
                    whenSession: {
                        store_code: ['ALL_STORES']
                    }
                }
            },
            whenType: 'OR'
        }),
        items: [
            {
                text: {
                    vi: 'Chi phí dự án',
                    en: 'Project Costing',
                    fr: 'Coût projet',
                    es: 'Costeo proyecto',
                    id: 'Biaya proyek',
                    ja: 'プロジェクト原価',
                    zh: '项目成本',
                    ko: '프로젝트 비용',
                    hi: 'प्रोजेक्ट लागत',
                    ar: 'تكلفة المشروع'
                },
                path: '/exp/EXPAllocatePMs',
                visible: {
                    whenUserScreen: 'EXPAllocatePMs'
                },
                navBadge: { module: 'exp', table: 'EXPAllocatePM', searchConditions: { allocate_status: 'New' } }
            },
            {
                text: {
                    vi: 'Giá thành dịch vụ',
                    en: 'Service Costing',
                    fr: 'Coût service',
                    es: 'Costo servicio',
                    id: 'Biaya layanan',
                    ja: 'サービス原価',
                    zh: '服务成本',
                    ko: '서비스 비용',
                    hi: 'सेवा लागत',
                    ar: 'تكلفة الخدمة'
                },
                path: '/pnl/PNLServeCostings',
                // Bản PNL chỉ chạy khi không có sổ cái (có sổ cái dùng /gl/GLServeCostings).
                visible: {
                    whenUserScreen: 'PNLServeCostings',
                    whenSys: { use_Module_GL: { type: '!=', value: 1 } }
                },
                navBadge: { module: 'pnl', table: 'PNLServeCosting', searchConditions: { status: 'New' } }
            },
            {
                text: {
                    vi: 'Giá thành dịch vụ',
                    en: 'Service Costing',
                    fr: 'Coût service',
                    es: 'Costo servicio',
                    id: 'Biaya layanan',
                    ja: 'サービス原価',
                    zh: '服务成本',
                    ko: '서비스 비용',
                    hi: 'सेवा लागत',
                    ar: 'تكلفة الخدمة'
                },
                path: '/gl/GLServeCostings',
                visible: {
                    whenUserScreen: 'GLServeCostings'
                },
                navBadge: { module: 'gl', table: 'GLServeCosting', searchConditions: { costing_status: ['New', 'Release', 'Rejected'] } }
            },
            {
                text: {
                    vi: 'Giá thành sản xuất',
                    en: 'Manufacturing Costing',
                    fr: 'Coût fabrication',
                    es: 'Costeo fabricación',
                    id: 'Biaya manufaktur',
                    ja: '製造原価',
                    zh: '制造成本',
                    ko: '제조 비용',
                    hi: 'निर्माण लागत',
                    ar: 'تكلفة التصنيع'
                },
                path: '/gl/GLMFCostings',
                visible: {
                    whenUserScreen: 'GLMFCostings'
                },
                navBadge: { module: 'gl', table: 'GLMFCosting', searchConditions: { costing_status: ['New', 'Release', 'Rejected'] } }
            }
        ]
    },
    // {
    //     text: {
    //         vi: 'Hạch toán',
    //         en: 'Auto Journals',
    //         fr: 'Journaux automatiques',
    //         es: 'Diarios automáticos',
    //         id: 'Jurnal otomatis',
    //         ja: '自動仕訳',
    //         zh: '自动日志',
    //         ko: '자동 분개',
    //         hi: 'स्वचालित जर्नल',
    //         ar: 'اليوميات التلقائية'
    //     },
    //     icon: icon_profit_lost,
    //     distinctable: false,
    //     visible: {
    //         whenSys: {
    //             use_Module_PNL: 1
    //         },
    //         whenUser: {
    //             view_Module_PNL: 1
    //         },

    //         when: {
    //             gr1: {
    //                 whenSys: {
    //                     store_qty: { type: '<', value: 2 }
    //                 }
    //             },
    //             gr2: {
    //                 whenSession: {
    //                     store_code: ['ALL_STORES']
    //                 }
    //             }
    //         },
    //         whenType: 'OR'
    //     },
    //     items: [
    //         {
    //             text: {
    //                 vi: 'Hạch toán tự động',
    //                 en: 'Auto Journals',
    //                 fr: 'Journaux automatiques',
    //                 es: 'Diarios automáticos',
    //                 id: 'Jurnal otomatis',
    //                 ja: '自動仕訳',
    //                 zh: '自动日志',
    //                 ko: '자동 분개',
    //                 hi: 'स्वचालित जर्नल',
    //                 ar: 'اليوميات التلقائية'
    //             },
    //             path: '/pnl/PNLJournals',
    //             visible: {
    //                 whenUserScreen: 'PNLJournals'
    //             }
    //         }
    //     ]
    // },
    {
        text: {
            vi: 'Kế toán',
            en: 'Accounting',
            fr: 'Comptabilité',
            es: 'Contabilidad',
            id: 'Akuntansi',
            ja: '会計',
            zh: '会计',
            ko: '회계',
            hi: 'लेखांकन',
            ar: 'المحاسبة'
        },
        icon: icon_procedure,
        distinctable: false,
        visible: withoutAccountingMode({
            // Người vào được chế độ Kế toán: nhóm này chỉ hiện ở chế độ Kế toán.
            when: {
                gr1: {
                    whenSys: {
                        store_qty: { type: '<', value: 2 }
                    }
                },
                gr2: {
                    whenSession: {
                        store_code: ['ALL_STORES']
                    }
                }
            },
            whenType: 'OR'
        }),
        items: [
            // Đợt 5 (TH-00): Chờ ghi sổ, Phiếu kế toán, Hạch toán lại gộp thành một danh sách Phiếu kế toán
            // (/gl/GLJournals); liên kết cũ chuyển hướng. Cùng visible và navBadge với mục TH-00 của thực đơn Kế toán.
            {
                text: {
                    vi: 'Phiếu kế toán',
                    en: 'Journal Voucher',
                    fr: 'Pièce comptable',
                    es: 'Comprobante diario',
                    id: 'Voucher jurnal',
                    ja: '仕訳伝票',
                    zh: '记账凭证',
                    ko: '분개 전표',
                    hi: 'जर्नल वाउचर',
                    ar: 'قسيمة اليومية'
                },
                path: '/gl/GLJournals',
                visible: withoutAccountingMode({
                    whenUserScreen: 'GLJournals'
                }),
                navBadge: { module: 'gl', table: 'GLVoucher', searchConditions: { ledger_status: ['Pending', 'Error'] } }
            },
            // Chủ động ẩn GLAccountingPolicy cho tới khi cầu nối kế toán ngoài
            // có đủ luồng đẩy, kéo và đối soát dữ liệu thật.
            {
                text: {
                    vi: 'Nhật ký chung',
                    en: 'General Journal',
                    fr: 'Journal général',
                    es: 'Diario general',
                    id: 'Jurnal umum',
                    ja: '仕訳帳',
                    zh: '普通日记账',
                    ko: '일반 분개장',
                    hi: 'सामान्य जर्नल',
                    ar: 'اليومية العامة'
                },
                path: '/gl/GLPostedJournals',
                visible: withoutAccountingMode({
                    whenUserScreen: 'GLPostedJournals'
                })
            },
            {
                text: {
                    vi: 'Xác định KQKD',
                    en: 'P&L Calculation',
                    fr: 'Calcul P&L',
                    es: 'Cálculo P&L',
                    id: 'Perhitungan L/R',
                    ja: '損益計算',
                    zh: '损益计算',
                    ko: '손익 계산',
                    hi: 'लाभ-हानि गणना',
                    ar: 'حساب الربح والخسارة'
                },
                path: '/gl/GLPNLCalculates',
                visible: withoutAccountingMode({
                    whenUserScreen: 'GLPNLCalculates'
                }),
                navBadge: { module: 'gl', table: 'GLPNLCalculate', searchConditions: { pnl_calculate_status: ['New', 'Release'] } }
            },
            {
                text: {
                    vi: 'Đóng kỳ kế toán',
                    en: 'Closing Periods',
                    fr: 'Clôture périodes',
                    es: 'Cierre períodos',
                    id: 'Tutup periode',
                    ja: '期間締め',
                    zh: '关闭期间',
                    ko: '기간 마감',
                    hi: 'अवधि समापन',
                    ar: 'إغلاق الفترات'
                },
                path: '/gl/GLPeriodClosings',
                visible: withoutAccountingMode({
                    whenUserScreen: 'GLPeriodClosings'
                })
            }
        ]
    },
    {
        text: {
            vi: 'Thuế',
            en: 'Tax',
            fr: 'Taxe',
            es: 'Impuesto',
            id: 'Pajak',
            ja: '税金',
            zh: '税务',
            ko: '세금',
            hi: 'कर',
            ar: 'ضريبة'
        },
        icon: icon_tax,
        distinctable: false,
        // Người vào được chế độ Kế toán: mọi màn Thuế (gồm Hóa đơn, Chờ xuất, Chờ nhận) chỉ ở chế độ Kế toán.
        visible: withoutAccountingMode({
            whenSys: {
                use_Module_Tax: 1
            },
            whenUser: {
                view_Module_Tax: 1
            },

            when: {
                gr1: {
                    whenSys: {
                        store_qty: { type: '<', value: 2 }
                    }
                },
                gr2: {
                    whenSession: {
                        store_code: ['ALL_STORES']
                    }
                }
            },
            whenType: 'OR'
        }),
        items: [
            {
                text: {
                    vi: 'Chờ xuất',
                    en: 'Pending Output',
                    fr: 'Sortie en attente',
                    es: 'Salida pendiente',
                    id: 'Keluaran tertunda',
                    ja: '発行待ち',
                    zh: '待开票',
                    ko: '발행 대기',
                    hi: 'जारी प्रतीक्षा',
                    ar: 'في انتظار الإصدار'
                },
                path: '/tax/SaleInvoicables',
                // Không có gói Kế toán: doanh nghiệp, hoặc người nộp thuế GTGT (hộ dưới ngưỡng không chịu thuế thì ẩn).
                // Có gói Kế toán luôn là Company nên giữ như cũ.
                visible: [
                    { whenUserScreens: ['ARInvoices', 'EXRInvoices'], whenSys: { business_model: 'Company' } },
                    { whenUserScreens: ['ARInvoices', 'EXRInvoices'], whenSys: { Tax_VAT_method: ['Direct', 'Credit'] } }
                ],
                navBadge: {
                    module: 'ar',
                    table: 'ARCredit',
                    searchConditions: {
                        type: 'Init',
                        credit_status: ['Close'],
                        total_invoicable_net_amt: { type: '!=', value: 0 }
                    }
                }
            },
            {
                text: {
                    vi: 'Chờ nhận',
                    en: 'Pending Input',
                    fr: 'Entrée en attente',
                    es: 'Entrada pendiente',
                    id: 'Masukan tertunda',
                    ja: '受領待ち',
                    zh: '待收票',
                    ko: '수령 대기',
                    hi: 'प्राप्ति प्रतीक्षा',
                    ar: 'في انتظار الاستلام'
                },
                path: '/tax/PurchaseInvoicables',
                // Không có gói Kế toán: doanh nghiệp, người nộp thuế GTGT khấu trừ, hoặc tính thuế trên thu nhập (cần hóa đơn đầu vào làm chi phí).
                visible: [
                    { whenUserScreens: ['APInvoices', 'EXPInvoices'], whenSys: { business_model: 'Company' } },
                    { whenUserScreens: ['APInvoices', 'EXPInvoices'], whenSys: { Tax_VAT_method: 'Credit' } },
                    { whenUserScreens: ['APInvoices', 'EXPInvoices'], whenSys: { Tax_PIT_basis: 'Profit' } }
                ],
                navBadge: {
                    module: 'ap',
                    table: 'APCredit',
                    searchConditions: {
                        type: 'Init',
                        credit_status: ['Close'],
                        total_invoicable_net_amt: { type: '!=', value: 0 }
                    }
                }
            },
            {
                text: {
                    vi: 'Hóa đơn',
                    en: 'Invoices',
                    fr: 'Factures',
                    es: 'Facturas',
                    id: 'Faktur',
                    ja: '請求書',
                    zh: '发票',
                    ko: '송장',
                    hi: 'चालान',
                    ar: 'فواتير'
                },
                path: '/tax/Invoices',
                visible: { whenUserScreens: ['ARInvoices', 'APInvoices', 'EXPInvoices', 'EXRInvoices', 'InvoiceAdjustments', 'EInvoiceLogs'] }
            },
            {
                text: {
                    vi: 'Bảng kê mua vào',
                    en: 'VAT Input Report',
                    fr: 'Rapport de TVA entrante',
                    es: 'Informe de IVA soportado',
                    id: 'Laporan PPN Masukan',
                    ja: 'VAT仕入レポート',
                    zh: '增值税进项报告',
                    ko: '부가세 매입 보고서',
                    hi: 'वैट इनपुट रिपोर्ट',
                    ar: 'تقرير ضريبة القيمة المضافة للمدخلات'
                },
                path: '/tax/VATInputReports',
                // Không có gói: chỉ thuế GTGT khấu trừ. Có gói mà không vào được chế độ Kế toán: theo điều kiện của chế độ Kế toán (THUE-03).
                // Tương tự Tờ khai (hộ kinh doanh) và Đối chiếu TNCN năm (có Lương).
                visible: withoutAccountingMode({ whenUserScreen: 'VATInputReports', whenSys: { Tax_VAT_method: 'Credit' } }, { whenUserScreen: 'VATInputReports' })
            },
            {
                text: {
                    vi: 'Bảng kê bán ra',
                    en: 'VAT Output Report',
                    fr: 'Rapport de TVA sortante',
                    es: 'Informe de IVA repercutido',
                    id: 'Laporan PPN Keluaran',
                    ja: 'VAT売上レポート',
                    zh: '增值税销项报告',
                    ko: '부가세 매출 보고서',
                    hi: 'वैट आउटपुट रिपोर्ट',
                    ar: 'تقرير ضريبة القيمة المضافة للمخرجات'
                },
                path: '/tax/VATOutputReports',
                visible: withoutAccountingMode({ whenUserScreen: 'VATOutputReports' })
            },
            {
                text: {
                    vi: 'Tờ khai thuế',
                    en: 'Tax returns',
                    fr: 'Déclarations',
                    es: 'Declaraciones',
                    id: 'SPT pajak',
                    ja: '税務申告',
                    zh: '纳税申报',
                    ko: '세무 신고',
                    hi: 'कर विवरणी',
                    ar: 'الإقرارات الضريبية'
                },
                path: '/tax/VATDeclarations',
                // Không có gói Kế toán: chỉ hộ kinh doanh (doanh nghiệp khai từ sổ kế toán). Biểu mẫu theo nước: cờ Tax_has_declaration của mã màn.
                visible: withoutAccountingMode([{ whenUserScreen: 'VATDeclarations', whenSys: { business_model: 'Individual' } }], [{ whenUserScreen: 'VATDeclarations' }])
            },
            // Dữ liệu lấy từ phiếu lương: chỉ khi có Lương. Tính thuế TNDN cần lợi nhuận kế toán nên chỉ ở chế độ Kế toán (THUE-05).
            {"text": {"vi": "Đối chiếu TNCN năm", "en": "Annual personal income tax"}, "path": "/tax/PITAnnuals", "visible": withoutAccountingMode({"whenUserScreen": "PITAnnuals", "whenSys": {"use_Module_Payroll": 1}}, {"whenUserScreen": "PITAnnuals"})},
            {
                text: {
                    vi: 'Sổ kế toán thuế',
                    en: 'Tax books',
                    fr: 'Livres fiscaux',
                    es: 'Libros fiscales',
                    id: 'Buku pajak',
                    ja: '税務帳簿',
                    zh: '税务账簿',
                    ko: '세무 장부',
                    hi: 'कर बहियाँ',
                    ar: 'الدفاتر الضريبية'
                },
                path: '/tax/TaxBooks',
                visible: [{ whenUserScreen: 'TaxBooks', whenSys: { use_Module_GL: { type: '!=', value: 1 } } }]
            }
        ]
    },
    {
        text: {
            vi: 'Dự án',
            en: 'Project',
            fr: 'Projet',
            es: 'Proyecto',
            id: 'Proyek',
            ja: 'プロジェクト',
            zh: '项目',
            ko: '프로젝트',
            hi: 'परियोजना',
            ar: 'المشروع'
        },
        icon: icon_project,
        visible: { whenSys: { use_Module_PM: 1 } },
        items: [
            {
                text: {
                    vi: 'Dự án của tôi',
                    en: 'My Projects',
                    fr: 'Mes projets',
                    es: 'Mis proyectos',
                    id: 'Proyek saya',
                    ja: 'マイプロジェクト',
                    zh: '我的项目',
                    ko: '내 프로젝트',
                    hi: 'मेरी परियोजनाएं',
                    ar: 'مشاريعي'
                },
                path: '/pm/PMWorkspaces',
                visible: {
                    whenSys: { use_Module_PM: 1, use_Module_PMSchedule: 1 },
                    whenUser: { view_Module_PM: 1 }
                }
            },
            {
                text: {
                    vi: 'Tài nguyên dự án',
                    en: 'Project Resources',
                    fr: 'Ressources du projet',
                    es: 'Recursos del proyecto',
                    id: 'Sumber daya proyek',
                    ja: 'プロジェクトリソース',
                    zh: '项目资源',
                    ko: '프로젝트 리소스',
                    hi: 'परियोजना संसाधन',
                    ar: 'موارد المشروع'
                },
                path: '/pm/PMResources',
                visible: {
                    whenUserScreen: 'PMResources'
                }
            },
            {
                text: {
                    vi: 'Khuôn mẫu dự án',
                    en: 'Project Templates',
                    fr: 'Modèles de projet',
                    es: 'Plantillas de proyecto',
                    id: 'Template proyek',
                    ja: 'プロジェクトテンプレート',
                    zh: '项目模板',
                    ko: '프로젝트 템플릿',
                    hi: 'परियोजना टेम्पलेट्स',
                    ar: 'قوالب المشروع'
                },
                path: '/pm/PMProjectTemplates',
                visible: {
                    whenUserScreen: 'PMProjectTemplates'
                }
            },
            {
                text: {
                    vi: 'Công việc',
                    en: 'Tasks',
                    fr: 'Tâches',
                    es: 'Tareas',
                    id: 'Tugas',
                    ja: 'タスク',
                    zh: '任务',
                    ko: '업무',
                    hi: 'कार्य',
                    ar: 'مهام'
                },
                path: '/of/OFTasks',
                visible: {
                    whenUserScreen: 'OFTasks'
                },
                navBadge: { module: 'of', table: 'OFTask', searchConditions: { task_status: ['ToDo', 'WIP'] } }
            },
            {
                text: {
                    vi: 'Báo cáo công việc',
                    en: 'Daily Reports',
                    fr: 'Rapports quotidiens',
                    es: 'Informes diarios',
                    id: 'Laporan harian',
                    ja: '日報',
                    zh: '日报',
                    ko: '일일보고',
                    hi: 'दैनिक रिपोर्ट',
                    ar: 'التقارير اليومية'
                },
                path: '/of/OFDailyReports',
                visible: {
                    whenUserScreen: 'OFDailyReports'
                },
                navBadge: { module: 'of', table: 'OFDailyReport', searchConditions: { report_status: 'Submitted' } }
            },
            {
                text: {
                    vi: 'Cuộc họp',
                    en: 'Meetings',
                    fr: 'Réunions',
                    es: 'Reuniones',
                    id: 'Rapat',
                    ja: '会議',
                    zh: '会议',
                    ko: '회의',
                    hi: 'बैठकें',
                    ar: 'الاجتماعات'
                },
                path: '/of/OFMeetings',
                visible: { whenUserScreen: 'OFMeetings' },
                navBadge: { module: 'of', table: 'OFMeeting', searchConditions: { meeting_status: 'Scheduled' } }
            },
            {
                text: {
                    vi: 'Phòng họp',
                    en: 'Meeting Rooms',
                    fr: 'Salles',
                    es: 'Salas',
                    id: 'Ruang rapat',
                    ja: '会議室',
                    zh: '会议室',
                    ko: '회의실',
                    hi: 'कमरे',
                    ar: 'الغرف'
                },
                path: '/of/OFMeetingRooms',
                visible: { whenUserScreen: 'OFMeetingRooms' }
            },
            // OFDocuments + OFDocFolders ẨN khỏi nav — access qua rightSidebar
            // panel 'documents' (label 'Công văn'). Route /of/OFDocuments vẫn
            // hoạt động nếu cần navigate trực tiếp.
            {
                text: {
                    vi: 'Bảng tin',
                    en: 'Bulletins',
                    fr: 'Bulletins',
                    es: 'Boletines',
                    id: 'Buletin',
                    ja: '掲示板',
                    zh: '公告',
                    ko: '게시판',
                    hi: 'बुलेटिन',
                    ar: 'النشرات'
                },
                path: '/of/OFBulletins',
                visible: { whenUserScreen: 'OFBulletins' },
                navBadge: { module: 'of', table: 'OFBulletin', searchConditions: { bulletin_status: 'Published' } }
            },
            {
                text: {
                    vi: 'Mục tiêu OKR',
                    en: 'OKR Objectives',
                    fr: 'Objectifs OKR',
                    es: 'Objetivos OKR',
                    id: 'Tujuan OKR',
                    ja: 'OKR目標',
                    zh: 'OKR目标',
                    ko: 'OKR 목표',
                    hi: 'OKR उद्देश्य',
                    ar: 'أهداف OKR'
                },
                path: '/of/OFObjectives',
                visible: { whenUserScreen: 'OFObjectives' },
                navBadge: { module: 'of', table: 'OFObjective', searchConditions: { objective_status: ['Draft', 'Active'] } }
            },
            {
                text: {
                    vi: 'Dashboard đội nhóm',
                    en: 'Team Dashboard',
                    fr: 'Tableau de bord',
                    es: 'Panel del equipo',
                    id: 'Dashboard tim',
                    ja: 'チームダッシュボード',
                    zh: '团队看板',
                    ko: '팀 대시보드',
                    hi: 'टीम डैशबोर्ड',
                    ar: 'لوحة الفريق'
                },
                path: '/of/OFTeamDashboard',
                visible: { whenUserScreen: 'OFTeamDashboard' }
            }
        ]
    },
    // {
    //     text: 'Nhân sự',
    //     icon: icon_employee,
    //     items: [
    //         {
    //             text: 'Nhân viên',
    //             path: '/hrm/Employees',
    //             visible: {
    //                 whenUserScreen: 'Employees'
    //             }
    //         }
    //     ]
    // },
    {
        text: {
            vi: 'Nhân sự',
            en: 'HR',
            fr: 'RH',
            es: 'RR. HH.',
            id: 'SDM',
            ja: '人事',
            zh: '人事',
            ko: '인사',
            hi: 'मानव संसाधन',
            ar: 'الموارد البشرية'
        },
        icon: icon_employee,
        items: [
            {
                text: {
                    vi: 'Chấm công',
                    en: 'Checkin',
                    fr: 'Pointage RH',
                    es: 'Marcaje RRHH',
                    id: 'Absen HR',
                    ja: 'HR打刻',
                    zh: 'HR签到',
                    ko: 'HR 체크인',
                    hi: 'HR चेक-इन',
                    ar: 'تسجيل الحضور'
                },
                path: '/pos/HRWorkingAttendance',
                visible: {
                    whenUserScreen: 'HRAttendanceQRDisplay'
                }
            },
            {
                text: {
                    vi: 'Nhật ký',
                    en: 'Attendance log',
                    fr: 'Journal de présence',
                    es: 'Registro de asistencia',
                    id: 'Log kehadiran',
                    ja: '勤怠記録',
                    zh: '考勤日志',
                    ko: '근태 기록',
                    hi: 'उपस्थिति लॉग',
                    ar: 'سجل الحضور'
                },
                path: '/timesheet/HRWorkingAttendanceLogs',
                visible: {
                    whenUserScreen: 'HRWorkingAttendances'
                }
            },
            {
                text: {
                    vi: 'Bổ sung',
                    en: 'Request',
                    fr: 'Régularisation pointage',
                    es: 'Solicitud de asistencia',
                    id: 'Permintaan absensi',
                    ja: '打刻修正申請',
                    zh: '补卡申请',
                    ko: '근태 정정',
                    hi: 'उपस्थिति अनुरोध',
                    ar: 'طلب تصحيح الحضور'
                },
                path: '/hrm/HRAttendanceRequests',
                visible: {
                    whenUserScreen: 'HRAttendanceRequests'
                },
                navBadge: { module: 'timesheet', table: 'HRAttendanceRequest', searchConditions: { request_status: 'New' } }
            },
            {
                text: {
                    vi: 'Chấm công hộ',
                    en: 'Proxy attendance',
                    fr: 'Pointage pour autrui',
                    es: 'Registro por otros',
                    id: 'Absensi mewakili',
                    ja: '代理打刻',
                    zh: '代打卡',
                    ko: '대리 출퇴근',
                    hi: 'प्रॉक्सी उपस्थिति',
                    ar: 'الحضور بالنيابة'
                },
                path: '/timesheet/RollCalls',
                visible: {
                    whenUserScreen: 'RollCalls'
                },
                navBadge: { module: 'timesheet', table: 'HRAttendanceBatch', searchConditions: { work_date_today: true } }
            },
            {
                text: {
                    vi: 'Tăng ca',
                    en: 'Overtime',
                    fr: 'Heures sup.',
                    es: 'Horas extra',
                    id: 'Lembur',
                    ja: '残業',
                    zh: '加班',
                    ko: '초과근무',
                    hi: 'ओवरटाइम',
                    ar: 'العمل الإضافي'
                },
                path: '/timesheet/HROvertimeRequests',
                visible: {
                    whenUserScreen: 'OvertimeRequests'
                },
                navBadge: { module: 'timesheet', table: 'HROvertimeRequest', searchConditions: { request_status: 'New' } }
            },
            {
                text: {
                    vi: 'Chốt công',
                    en: 'Confirm attendance',
                    fr: 'Confirmer les présences',
                    es: 'Confirmar asistencia',
                    id: 'Konfirmasi kehadiran',
                    ja: '勤怠確定',
                    zh: '考勤确认',
                    ko: '근태 확정',
                    hi: 'उपस्थिति पुष्टि',
                    ar: 'تأكيد الحضور'
                },
                path: '/timesheet/HRWorkingAttendances',
                visible: {
                    whenUserScreen: 'HRWorkingAttendances'
                },
                navBadge: {
                    module: 'timesheet',
                    table: 'HRWorkingDay',
                    searchConditions: {
                        day_status: ['Ready', 'ReviewRequired', 'Reopened']
                    }
                }
            },
            {
                text: {
                    vi: 'Nghỉ phép',
                    en: 'Leave',
                    fr: 'Congés',
                    es: 'Permisos',
                    id: 'Cuti',
                    ja: '休暇',
                    zh: '请假',
                    ko: '휴가',
                    hi: 'अवकाश',
                    ar: 'الإجازات'
                },
                path: '/hrm/HRLeaves',
                visible: {
                    whenUserScreen: 'HRLeaves'
                },
                navBadge: { module: 'timesheet', table: 'HRLeave', searchConditions: { leave_status: 'New' } }
            },
            {
                text: {
                    vi: 'Tính công',
                    en: 'Timesheet',
                    fr: 'Feuille de temps',
                    es: 'Hoja de horas',
                    id: 'Absensi',
                    ja: 'タイムシート',
                    zh: '考勤表',
                    ko: '근무기록',
                    hi: 'टाइमशीट',
                    ar: 'جدول الحضور'
                },
                path: '/timesheet/HRWorkingTimesheets',
                visible: {
                    whenUserScreen: 'HRWorkingTimesheets'
                },
                navBadge: {
                    module: 'timesheet',
                    table: 'HRWorkingTimesheet',
                    searchConditions: {
                        timesheet_status: 'New'
                    }
                }
            }
        ]
    },
    {
        text: {
            vi: 'Lương',
            en: 'Payroll',
            fr: 'Paie',
            es: 'Nómina',
            id: 'Penggajian',
            ja: '給与計算',
            zh: '工资单',
            ko: '급여',
            hi: 'पेरोल',
            ar: 'الرواتب'
        },
        icon: icon_payroll,
        visible: {
            when: {
                gr1: {
                    whenSys: {
                        store_qty: { type: '<', value: 2 }
                    }
                },
                gr2: {
                    whenSession: {
                        store_code: ['ALL_STORES']
                    }
                }
            },
            whenType: 'OR'
        },
        items: [
            {
                text: {
                    vi: 'Lương Thời Gian',
                    en: 'Working Salary',
                    fr: 'Salaire travail',
                    es: 'Salario trabajo',
                    id: 'Gaji kerja',
                    ja: '勤務給与',
                    zh: '工作工资',
                    ko: '근무 급여',
                    hi: 'कार्य वेतन',
                    ar: 'راتب العمل'
                },
                path: '/payroll/HRWorkingSalarys',
                visible: {
                    whenUserScreen: 'HRWorkingSalarys'
                },
                navBadge: { module: 'payroll', table: 'HRWorkingSalary', searchConditions: { mix_status: ['New', 'Release'] } }
            },
            {
                text: {
                    vi: 'Lương Kinh Doanh',
                    en: 'Employee Commission',
                    fr: 'Commission employé',
                    es: 'Comisión empleado',
                    id: 'Komisi karyawan',
                    ja: '従業員手数料',
                    zh: '员工佣金',
                    ko: '직원 수수료',
                    hi: 'कर्मचारी कमीशन',
                    ar: 'عمولة الموظف'
                },
                path: '/payroll/HRCommisions',
                visible: {
                    whenUserScreen: 'HRCommisions'
                },
                navBadge: { module: 'payroll', table: 'HRCommision', searchConditions: { mix_status: ['New', 'Release'] } }
            },
            {
                text: {
                    vi: 'Phụ cấp',
                    en: 'Employee Allowance',
                    fr: 'Indemnité employé',
                    es: 'Subsidio empleado',
                    id: 'Tunjangan karyawan',
                    ja: '従業員手当',
                    zh: '员工津贴',
                    ko: '직원 수당',
                    hi: 'कर्मचारी भत्ता',
                    ar: 'بدل الموظف'
                },
                path: '/payroll/HRAllowances',
                visible: {
                    whenUserScreen: 'HRAllowances'
                },
                navBadge: { module: 'payroll', table: 'HRAllowance', searchConditions: { mix_status: ['New', 'Release'] } }
            },
            {
                text: {
                    vi: 'Phiếu tăng ca tháng',
                    en: 'Monthly overtime slips',
                    fr: 'Relevés mensuels d’heures sup.',
                    es: 'Partes mensuales de horas extra',
                    id: 'Slip lembur bulanan',
                    ja: '月次残業伝票',
                    zh: '月度加班单',
                    ko: '월별 초과근무 전표',
                    hi: 'मासिक ओवरटाइम पर्चियाँ',
                    ar: 'قسائم العمل الإضافي الشهرية'
                },
                path: '/payroll/HROvertimes',
                visible: {
                    whenUserScreen: 'HROvertimes'
                },
                navBadge: { module: 'payroll', table: 'HROvertime', searchConditions: { overtime_status: ['New', 'Release'] } }
            },
            {
                text: {
                    vi: 'Điều chỉnh lương',
                    en: 'Salary Adjust',
                    fr: 'Ajustement salaire',
                    es: 'Ajuste salario',
                    id: 'Penyesuaian gaji',
                    ja: '給与調整',
                    zh: '工资调整',
                    ko: '급여 조정',
                    hi: 'वेतन समायोजन',
                    ar: 'تعديل الراتب'
                },
                path: '/payroll/HRAdjusts',
                visible: {
                    whenUserScreen: 'HRAdjusts'
                },
                navBadge: { module: 'payroll', table: 'HRAdjust', searchConditions: { mix_status: ['New', 'Release'] } }
            },
            {
                text: {
                    vi: 'Phiếu Lương',
                    en: 'Salary Ticket',
                    fr: 'Ticket salaire',
                    es: 'Ticket salario',
                    id: 'Tiket gaji',
                    ja: '給与チケット',
                    zh: '工资单',
                    ko: '급여 티켓',
                    hi: 'वेतन टिकट',
                    ar: 'تذكرة الراتب'
                },
                path: '/payroll/HROrders',
                visible: {
                    whenUserScreen: 'HROrders'
                },
                navBadge: { module: 'payroll', table: 'HROrder', searchConditions: { mix_status: ['New', 'Release', 'Open'] } }
            },
            {
                text: {
                    vi: 'Trả Lương',
                    en: 'Payroll Disbursement'
                },
                path: '/payroll/HRPayments',
                visible: {
                    whenUserScreen: 'HRPayments'
                }
            }
        ]
    },
    {
        text: {
            vi: 'Báo Cáo',
            en: 'Reports',
            fr: 'Rapports',
            es: 'Informes',
            id: 'Laporan',
            ja: 'レポート',
            zh: '报告',
            ko: '보고서',
            hi: 'रिपोर्ट',
            ar: 'التقارير'
        },
        icon: icon_report,
        distinctable: true,
        items: [
            {
                text: {
                    vi: 'Doanh thu',
                    en: 'Daily Revenue',
                    fr: 'Revenus quotidiens',
                    es: 'Ingresos diarios',
                    id: 'Pendapatan harian',
                    ja: '日次売上',
                    zh: '每日收入',
                    ko: '일일 매출',
                    hi: 'दैनिक राजस्व',
                    ar: 'الإيرادات اليومية'
                },
                path: '/rpt/rptARRevenue',
                visible: [
                    { whenUserScreen: 'rptARDailyRevenue' },
                    { whenUserScreen: 'rptARRevenueByItem' },
                    { whenUserScreen: 'rptARRevenueByCatalogue' },
                    {
                        whenUserScreen: 'rptARRevenueByStore',
                        when: {
                            gr1: { whenSys: { store_qty: { type: '<', value: 2 } } },
                            gr2: { whenSession: { store_code: ['ALL_STORES'] } }
                        },
                        whenType: 'OR'
                    }
                ]
            },
            // {
            //     text: {
            //         vi: 'Doanh thu mặt hàng',
            //         en: 'Product Revenue',
            //         fr: 'Revenus produit',
            //         es: 'Ingresos producto',
            //         id: 'Pendapatan produk',
            //         ja: '製品売上',
            //         zh: '产品收入',
            //         ko: '제품 매출',
            //         hi: 'उत्पाद राजस्व',
            //         ar: 'إيرادات المنتج'
            //     },
            //     path: '/rpt/rptARRevenueByItem',
            //     visible: {
            //         whenUserScreen: 'rptARRevenueByItem'
            //     }
            // },
            // {
            //     text: {
            //         vi: 'Doanh thu mặt hàng (SL)',
            //         en: 'Product Revenue (qty)',
            //         fr: 'Revenus produit (qté)',
            //         es: 'Ingresos producto (cant)',
            //         id: 'Pendapatan produk (jml)',
            //         ja: '製品売上(数量)',
            //         zh: '产品收入(数量)',
            //         ko: '제품 매출(수량)',
            //         hi: 'उत्पाद राजस्व (मात्रा)',
            //         ar: 'إيرادات المنتج (كمية)'
            //     },
            //     path: '/rpt/rptARRevenueQtyByItem',
            //     visible: {
            //         whenUserScreen: 'rptARRevenueByItem'
            //     }
            // },
            // {
            //     text: {
            //         vi: 'Doanh thu nhóm hàng',
            //         en: 'Catalogue Revenue',
            //         fr: 'Revenus catalogue',
            //         es: 'Ingresos catálogo',
            //         id: 'Pendapatan katalog',
            //         ja: 'カタログ売上',
            //         zh: '目录收入',
            //         ko: '카탈로그 매출',
            //         hi: 'कैटलॉग राजस्व',
            //         ar: 'إيرادات الكتالوج'
            //     },
            //     path: '/rpt/rptARRevenueByCatalogue',
            //     visible: {
            //         whenUserScreen: 'rptARRevenueByCatalogue'
            //     }
            // },
            // {
            //     text: {
            //         vi: 'Doanh thu cửa hàng',
            //         en: 'Store Revenue Report'
            //     },
            //     path: '/rpt/rptARRevenueByStore',
            //     visible: { whenUserScreen: 'rptARRevenueByStore' }
            // },
            // {
            //     text: {
            //         vi: 'Thống kê Trả hàng',
            //         en: 'Return by Product'
            //     },
            //     path: '/rpt/rptARReturnByItem',
            //     visible: {
            //         whenUserScreen: 'rptARReturnByItem'
            //     }
            // },
            // {
            //     text: {
            //         vi: 'Trả hàng theo cửa hàng',
            //         en: 'Return by Store'
            //     },
            //     path: '/rpt/rptARReturnByStore',
            //     visible: {
            //         whenUserScreen: 'rptARReturnByStore'
            //     }
            // },
            // {
            //     text: {
            //         vi: 'Xuất kho bán hàng',
            //         en: 'Inventory Issue'
            //     },
            //     path: '/rpt/rptICSaleIssueByItem',
            //     visible: {
            //         whenUserScreen: 'rptICSaleIssueByItem'
            //     }
            // },
            // {
            //     text: {
            //         vi: 'Nhập trả hàng bán',
            //         en: 'Inventory Receive'
            //     },
            //     path: '/rpt/rptICSaleReceiptByItem',
            //     visible: {
            //         whenUserScreen: 'rptICSaleReceiptByItem'
            //     }
            // },,
            {
                text: {
                    vi: 'Chi phí',
                    en: 'Expense Statistic',
                    fr: 'Statistiques dépenses',
                    es: 'Estadísticas gastos',
                    id: 'Statistik pengeluaran',
                    ja: '経費統計',
                    zh: '费用统计',
                    ko: '비용 통계',
                    hi: 'व्यय सांख्यिकी',
                    ar: 'إحصائيات المصروفات'
                },
                path: '/rpt/rptEXP',
                // 24/10: người vào được chế độ Kế toán thì chứng từ chi phí theo người lập — có ERP (use_Module_AR) nhân viên lập ở Vận hành, không ERP kế toán lập ở Kế toán.
                visible: [
                    ...withoutAccountingMode({ whenUserScreen: 'rptEXP', when: { gr1: { whenSys: { store_qty: { type: '<', value: 2 } } }, gr2: { whenSession: { store_code: ['ALL_STORES'] } } }, whenType: 'OR' }),
                    { whenUserScreen: 'rptEXP', whenSys: { use_Module_AR: 1 }, when: { gr1: { whenSys: { store_qty: { type: '<', value: 2 } } }, gr2: { whenSession: { store_code: ['ALL_STORES'] } } }, whenType: 'OR' }
                ]
            },
            {
                text: {
                    vi: 'Bán hàng',
                    en: 'AR Balance',
                    fr: 'Solde client',
                    es: 'Saldo cliente',
                    id: 'Saldo piutang',
                    ja: '売掛金残高',
                    zh: '应收账款余额',
                    ko: '매출채권 잔액',
                    hi: 'प्राप्य शेष',
                    ar: 'رصيد الذمم المدينة'
                },
                path: '/ar/ARBalance',
                visible: {
                    whenUserScreens: ['ARAgingReport', 'ARCustomerStatement']
                }
            },
            {
                text: {
                    vi: 'Mua hàng',
                    en: 'AP Balance',
                    fr: 'Solde fournisseur',
                    es: 'Saldo proveedor',
                    id: 'Saldo hutang',
                    ja: '買掛金残高',
                    zh: '应付账款余额',
                    ko: '매입채무 잔액',
                    hi: 'देय शेष',
                    ar: 'رصيد الذمم الدائنة'
                },
                path: '/ap/APBalance',
                visible: {
                    whenUserScreens: ['APAgingReport', 'APSupplierStatement']
                }
            },
            {
                text: {
                    vi: 'Nguyên liệu',
                    en: 'Cooking Material Consumption',
                    fr: 'Consommation matières cuisine',
                    es: 'Consumo materiales cocina',
                    id: 'Konsumsi bahan masak',
                    ja: '調理材料消費',
                    zh: '烹饪材料消耗',
                    ko: '조리 자재 소비',
                    hi: 'खाना पकाने की सामग्री उपभोग',
                    ar: 'استهلاك مواد الطبخ'
                },
                path: '/rpt/rptARServeMaterialByItem',
                visible: {
                    whenUserScreen: 'rptARServeMaterialByItem'
                }
            },
            {
                text: {
                    vi: 'Phụ cấp dịch vụ',
                    en: 'Serving Report',
                    fr: 'Rapport service',
                    es: 'Informe servicio',
                    id: 'Laporan pelayanan',
                    ja: 'サービスレポート',
                    zh: '服务报告',
                    ko: '서비스 보고서',
                    hi: 'सर्विंग रिपोर्ट',
                    ar: 'تقرير الخدمة'
                },
                path: '/serve/ARServeMonthlyReports',
                visible: {
                    whenUserScreen: 'ARServeMonthlyReports'
                }
            },
            {
                text: {
                    vi: 'Hoa hồng',
                    en: 'Commission',
                    fr: 'Commission',
                    es: 'Comisión',
                    id: 'Komisi',
                    ja: 'コミッション',
                    zh: '佣金',
                    ko: '수수료',
                    hi: 'कमीशन',
                    ar: 'عمولة'
                },
                path: '/coms/CRMComsInits',
                visible: {
                    whenUserScreen: 'CRMComsInits'
                },
                navBadge: {
                    module: 'coms',
                    table: 'CRMComsInit',
                    searchConditions: { commision_amt: { type: '!=', value: 0 }, month_id_withinCurrentMonth: 1 }
                }
            },
            {
                text: {
                    vi: 'Lời lỗ',
                    en: 'P&L Statement',
                    fr: 'Compte de résultat',
                    es: 'Estado de resultados',
                    id: 'Laporan laba rugi',
                    ja: '損益計算書',
                    zh: '损益表',
                    ko: '손익계산서',
                    hi: 'लाभ-हानि विवरण',
                    ar: 'بيان الأرباح والخسائر'
                },
                path: '/pnl/PNLMonthlyReports',
                visible: withoutAccountingMode({
                    whenUserScreen: 'PNLMonthlyReports',
                    when: {
                        gr1: {
                            whenSys: {
                                store_qty: { type: '<', value: 2 }
                            }
                        },
                        gr2: {
                            whenSession: {
                                store_code: ['ALL_STORES']
                            }
                        }
                    },
                    whenType: 'OR'
                })
            }
        ]
    },
    {
        text: {
            vi: 'Báo cáo tài chính',
            en: 'Financial Reports',
            fr: 'Rapports financiers',
            es: 'Informes financieros',
            id: 'Laporan keuangan',
            ja: '財務報告',
            zh: '财务报告',
            ko: '재무 보고서',
            hi: 'वित्तीय रिपोर्ट',
            ar: 'التقارير المالية'
        },
        icon: icon_report,
        // Người vào được chế độ Kế toán: nhóm này chỉ hiện ở chế độ Kế toán.
        visible: withoutAccountingMode({}),
        items: [
            {
                text: {
                    vi: 'Bảng cân đối kế toán',
                    en: 'Balance Sheet',
                    fr: 'Bilan',
                    es: 'Balance general',
                    id: 'Neraca',
                    ja: '貸借対照表',
                    zh: '资产负债表',
                    ko: '대차대조표',
                    hi: 'बैलेंस शीट',
                    ar: 'الميزانية العمومية'
                },
                path: '/gl/GLBalanceSheets',
                visible: withoutAccountingMode({
                    whenUserScreen: 'GLBalanceSheets'
                })
            },
            {
                text: {
                    vi: 'Kết quả kinh doanh',
                    en: 'P&L Statement',
                    fr: 'Compte de résultat',
                    es: 'Estado de resultados',
                    id: 'Laporan laba rugi',
                    ja: '損益計算書',
                    zh: '损益表',
                    ko: '손익계산서',
                    hi: 'लाभ-हानि विवरण',
                    ar: 'بيان الأرباح والخسائر'
                },
                path: '/gl/GLPNLReports',
                visible: withoutAccountingMode({
                    whenUserScreen: 'GLPNLReports',
                    when: {
                        gr1: {
                            whenSys: {
                                store_qty: { type: '<', value: 2 }
                            }
                        },
                        gr2: {
                            whenSession: {
                                store_code: ['ALL_STORES']
                            }
                        }
                    },
                    whenType: 'OR'
                })
            },
            {
                text: {
                    vi: 'Lưu chuyển tiền tệ',
                    en: 'Cash Flow Statement',
                    fr: 'État des flux de trésorerie',
                    es: 'Estado de flujos de efectivo',
                    id: 'Laporan Arus Kas',
                    ja: 'キャッシュ・フロー計算書',
                    zh: '现金流量表',
                    ko: '현금흐름표',
                    hi: 'नकदी प्रवाह विवरण',
                    ar: 'بيان التدفقات النقدية'
                },
                path: '/gl/GLCashFlowReports',
                visible: withoutAccountingMode({
                    whenUserScreen: 'GLCashFlowReports'
                })
            },
            {
                text: {
                    vi: 'Thay đổi vốn chủ sở hữu',
                    en: 'Changes in Equity',
                    fr: 'Variation des capitaux propres',
                    es: 'Cambios en el patrimonio',
                    id: 'Perubahan Ekuitas',
                    ja: '持分変動計算書',
                    zh: '所有者权益变动表',
                    ko: '자본변동표',
                    hi: 'इक्विटी में परिवर्तन',
                    ar: 'التغيرات في حقوق الملكية'
                },
                path: '/gl/GLEquityChanges',
                visible: withoutAccountingMode({
                    whenUserScreen: 'GLBalanceSheets'
                })
            },
            {
                text: {
                    vi: 'Cân Đối Số Phát Sinh',
                    en: 'Trial Balance',
                    fr: 'Balance des comptes',
                    es: 'Balance de comprobación',
                    id: 'Neraca Saldo',
                    ja: '残高試算表',
                    zh: '试算表',
                    ko: '시산표',
                    hi: 'परीक्षण शेष',
                    ar: 'ميزان المراجعة'
                },
                path: '/gl/GLTrialBalances',
                visible: withoutAccountingMode({
                    whenUserScreen: 'GLTrialBalances'
                })
            },
            {
                text: {
                    vi: 'Sổ cái tổng hợp',
                    en: 'General Ledger',
                    fr: 'Grand livre',
                    es: 'Libro mayor',
                    id: 'Buku besar',
                    ja: '総勘定元帳',
                    zh: '总账',
                    ko: '총계정원장',
                    hi: 'सामान्य खाता बही',
                    ar: 'دفتر الأستاذ العام'
                },
                path: '/gl/GLGeneralLedgers',
                visible: withoutAccountingMode({
                    whenUserScreen: 'GLGeneralLedgers'
                })
            },
            {
                text: {
                    vi: 'Sổ cái chi tiết',
                    en: 'General Ledger Detail',
                    fr: 'Détail grand livre',
                    es: 'Detalle libro mayor',
                    id: 'Detail buku besar',
                    ja: '元帳明細',
                    zh: '总账明细',
                    ko: '원장 상세',
                    hi: 'खाता बही विवरण',
                    ar: 'تفاصيل دفتر الأستاذ'
                },
                path: '/gl/GLGeneralLedgerDetails',
                visible: withoutAccountingMode({
                    whenUserScreen: 'GLGeneralLedgerDetails'
                })
            },
            {
                text: {
                    vi: 'Tổng hợp công nợ',
                    en: 'Entity Liability Summary',
                    fr: 'Résumé des créances/dettes',
                    es: 'Resumen de deudas/créditos',
                    id: 'Ringkasan Hutang/Piutang',
                    ja: '補助元帳（点）、、',
                    zh: '往来明细汇总',
                    ko: '거래처별 미결제 잔액 요약',
                    hi: 'सत्ता देयता सारांश',
                    ar: 'ملخص ديون الكيان'
                },
                path: '/gl/GLEntityLedgers',
                visible: withoutAccountingMode({
                    whenUserScreen: 'GLEntityLedgers'
                })
            }
        ]
    },
    {
        text: {
            vi: 'Cấu Hình',
            en: 'Setting',
            fr: 'Paramètres',
            es: 'Configuración',
            id: 'Pengaturan',
            ja: '設定',
            zh: '设置',
            ko: '설정',
            hi: 'सेटिंग',
            ar: 'الإعدادات'
        },
        icon: icon_setting,
        // distinctable: false,
        visible: {
            when: {
                gr1: {
                    whenSys: {
                        store_qty: { type: '<', value: 2 }
                    }
                },
                gr2: {
                    whenSession: {
                        store_code: ['ALL_STORES']
                    }
                }
            },
            whenType: 'OR'
        },
        items: [
            {
                text: {
                    vi: 'Tổng quan',
                    en: 'General',
                    fr: 'Généraux',
                    es: 'General',
                    id: 'Pengaturan umum',
                    ja: '一般設定',
                    zh: '常规设置',
                    ko: '일반 설정',
                    hi: 'सामान्य सेटिंग',
                    ar: 'الإعدادات العامة'
                },
                path: '/setting/General',
                visible: {
                    whenUserScreen: 'Setting_General'
                }
            },
            {
                text: {
                    vi: 'Sản phẩm',
                    en: 'Products',
                    fr: 'Produits',
                    es: 'Productos',
                    id: 'Produk',
                    ja: '製品',
                    zh: '产品',
                    ko: '제품',
                    hi: 'उत्पाद',
                    ar: 'المنتجات'
                },
                path: '/setting/Products',
                visible: [
                    { whenUserScreen: 'Setting_Goods' },
                    { whenUserScreen: 'Setting_Foods' },
                    { whenUserScreen: 'Setting_Beverages' },
                    { whenUserScreen: 'Setting_ExtraFees' },
                    { whenUserScreen: 'Setting_Materials' },
                    { whenUserScreen: 'Setting_FixedServices' },
                    { whenUserScreen: 'Setting_ExpandableServices' },
                    { whenUserScreen: 'Setting_ServicePacks' },
                    { whenUserScreen: 'Setting_DepositPacks' }
                ]
            },
            {
                text: {
                    vi: 'Biến thể',
                    en: 'Product Variant',
                    fr: 'Variante produit',
                    es: 'Variante producto',
                    id: 'Varian produk',
                    ja: '製品バリアント',
                    zh: '产品变体',
                    ko: '제품 변형',
                    hi: 'उत्पाद वेरिएंट',
                    ar: 'متغير المنتج'
                },
                path: '/setting/Variants',
                visible: {
                    whenUserScreen: 'Setting_Variants'
                }
            },
            // {
            //     text: {
            //         vi: 'Sản phẩm thay thế',
            //         en: 'Substitute Items',
            //         fr: 'Produits de substitution',
            //         es: 'Productos sustitutos',
            //         id: 'Produk pengganti',
            //         ja: '代替商品',
            //         zh: '替代品',
            //         ko: '대체 상품',
            //         hi: 'विकल्प उत्पाद',
            //         ar: 'منتجات بديلة'
            //     },
            //     path: '/setting/ItemSubstitutes',
            //     visible: {
            //         whenUserScreen: 'ItemSubstitutes'
            //     }
            // },
            {
                text: {
                    vi: 'Tồn kho',
                    en: 'Inventory',
                    fr: 'Inventaire',
                    es: 'Inventario',
                    id: 'Inventaris',
                    ja: '在庫設定',
                    zh: '库存设置',
                    ko: '재고 설정',
                    hi: 'इन्वेंट्री सेटिंग',
                    ar: 'إعدادات المخزون'
                },
                path: '/setting/inv',
                visible: [{ whenUserScreen: 'Setting_IC' }, { whenUserScreen: 'ICBOMs' }]
            },
            {
                text: {
                    vi: 'Hàng theo kho',
                    en: 'Product By Warehouse',
                    fr: 'Produit par entrepôt',
                    es: 'Producto por almacén',
                    id: 'Produk per gudang',
                    ja: '倉庫別製品',
                    zh: '按仓库产品',
                    ko: '창고별 제품',
                    hi: 'गोदाम द्वारा उत्पाद',
                    ar: 'المنتج حسب المستودع'
                },
                path: '/setting/ItemWarehouses',
                visible: {
                    whenUserScreen: 'Setting_ItemWarehouses'
                }
            },
            {
                text: {
                    vi: 'Bán hàng',
                    en: 'Sale',
                    fr: 'Paramètres vente',
                    es: 'Configuración venta',
                    id: 'Pengaturan penjualan',
                    ja: '販売設定',
                    zh: '销售设置',
                    ko: '판매 설정',
                    hi: 'बिक्री सेटिंग',
                    ar: 'إعدادات البيع'
                },
                path: '/setting/ar',
                visible: [
                    { whenUserScreen: 'Setting_AR' },
                    { whenUserScreen: 'Setting_Store' },
                    {
                        whenUserScreen: 'ARPriceLists',
                        whenSession: {
                            entity_type: { type: '!=', value: 'Customer' }
                        }
                    },
                    { whenUserScreen: 'ARPromotions' }
                ]
            },
            {
                text: {
                    vi: 'Thuế',
                    en: 'Tax',
                    fr: 'Fiscalité',
                    es: 'Impuestos',
                    id: 'Pajak',
                    ja: '税務',
                    zh: '税务',
                    ko: '세무',
                    hi: 'कर',
                    ar: 'الضرائب'
                },
                path: '/setting/tax',
                visible: withoutAccountingMode([{ whenUserScreen: 'Setting_Tax' }])
            },
            {
                text: {
                    vi: 'Giao hàng',
                    en: 'Logistic',
                    fr: 'Logistique',
                    es: 'Logística',
                    id: 'Logistik',
                    ja: '物流設定',
                    zh: '物流设置',
                    ko: '물류 설정',
                    hi: 'लॉजिस्टिक्स सेटिंग',
                    ar: 'إعدادات اللوجستيات'
                },
                path: '/setting/lg',
                visible: {
                    whenUserScreen: 'Setting_LG'
                }
            },
            {
                text: {
                    vi: 'Phục vụ',
                    en: 'Serving',
                    fr: 'Service',
                    es: 'Servicio',
                    id: 'Pelayanan',
                    ja: 'サービス設定',
                    zh: '服务设置',
                    ko: '서비스 설정',
                    hi: 'सर्विंग सेटिंग',
                    ar: 'إعدادات الخدمة'
                },
                path: '/setting/serve',
                visible: {
                    whenUserScreen: 'Setting_ARServe'
                }
            },
            {
                text: {
                    vi: 'Chế biến',
                    en: 'Cooking',
                    fr: 'Cuisine',
                    es: 'Cocina',
                    id: 'Memasak',
                    ja: '調理設定',
                    zh: '烹饪设置',
                    ko: '요리 설정',
                    hi: 'कुकिंग सेटिंग',
                    ar: 'إعدادات الطبخ'
                },
                path: '/setting/cooking',
                visible: {
                    whenUserScreen: 'Setting_ARCooking'
                }
            },
            {
                text: {
                    vi: 'Cho thuê',
                    en: 'Rental',
                    fr: 'Paramètres location',
                    es: 'Configuración alquiler',
                    id: 'Pengaturan sewa',
                    ja: 'レンタル設定',
                    zh: '租赁设置',
                    ko: '렌탈 설정',
                    hi: 'किराया सेटिंग',
                    ar: 'إعدادات الإيجار'
                },
                path: '/setting/rental',
                visible: {
                    whenUserScreen: 'Setting_ARRental'
                }
            },
            {
                text: {
                    vi: 'Người bán',
                    en: 'Vendor',
                    fr: 'Fournisseur',
                    es: 'Proveedor',
                    id: 'Vendor',
                    ja: 'ベンダー',
                    zh: '供应商',
                    ko: '공급업체',
                    hi: 'विक्रेता',
                    ar: 'البائع'
                },
                path: '/vrm/Vendors',
                visible: {
                    whenUserScreen: 'Vendors'
                }
            },
            {
                text: {
                    vi: 'Mua hàng',
                    en: 'Purchase',
                    fr: 'Paramètres achat',
                    es: 'Configuración compra',
                    id: 'Pengaturan pembelian',
                    ja: '仕入設定',
                    zh: '采购设置',
                    ko: '구매 설정',
                    hi: 'खरीद सेटिंग',
                    ar: 'إعدادات الشراء'
                },
                path: '/setting/ap',
                visible: {
                    whenUserScreen: 'Setting_AP'
                }
            },
            {
                text: {
                    vi: 'Cung ứng',
                    en: 'Supply Chain',
                    fr: 'Chaîne appro.',
                    es: 'Cadena suministro',
                    id: 'Rantai pasokan',
                    ja: 'サプライチェーン設定',
                    zh: '供应链设置',
                    ko: '공급망 설정',
                    hi: 'आपूर्ति श्रृंखला सेटिंग',
                    ar: 'إعدادات سلسلة التوريد'
                },
                path: '/setting/spc',
                visible: {
                    whenUserScreen: 'Setting_SPC'
                }
            },
            {
                text: {
                    vi: 'Sản xuất',
                    en: 'Manufacturing',
                    fr: 'Fabrication',
                    es: 'Fabricación',
                    id: 'Manufaktur',
                    ja: '製造設定',
                    zh: '制造设置',
                    ko: '제조 설정',
                    hi: 'निर्माण सेटिंग',
                    ar: 'إعدادات التصنيع'
                },
                path: '/setting/mf',
                visible: {
                    whenUserScreen: 'Setting_MF'
                }
            },
            {
                text: {
                    vi: 'Nhân sự',
                    en: 'Human Resource',
                    fr: 'Paramètres RH',
                    es: 'Configuración RRHH',
                    id: 'Pengaturan HRM',
                    ja: '人事設定',
                    zh: '人事设置',
                    ko: '인사 설정',
                    hi: 'HRM सेटिंग',
                    ar: 'إعدادات الموارد البشرية'
                },
                path: '/setting/hrm',
                visible: {
                    whenUserScreen: 'Setting_HRM'
                }
            },
            {
                text: {
                    vi: 'Chi tiêu',
                    en: 'Spending',
                    fr: 'Dépenses',
                    es: 'Gastos',
                    id: 'Pengeluaran',
                    ja: '支出',
                    zh: '支出',
                    ko: '지출',
                    hi: 'खर्च',
                    ar: 'الإنفاق'
                },
                path: '/setting/exp',
                visible: {
                    whenUserScreen: 'Setting_EXP'
                }
            },
            {
                text: {
                    vi: 'Sổ quỹ',
                    en: 'Cash Balance',
                    fr: 'Solde caisse',
                    es: 'Saldo caja',
                    id: 'Saldo kas',
                    ja: '現金残高',
                    zh: '现金余额',
                    ko: '현금 잔액',
                    hi: 'नकद शेष',
                    ar: 'رصيد النقدية'
                },
                path: '/setting/ca',
                visible: {
                    whenUserScreen: 'Setting_CAAccounts'
                }
            },
            {
                text: {
                    vi: 'Phải thu',
                    en: 'Receivable',
                    fr: 'Clients',
                    es: 'Por cobrar',
                    id: 'Piutang',
                    ja: '売掛設定',
                    zh: '应收设置',
                    ko: '미수금 설정',
                    hi: 'प्राप्य सेटिंग',
                    ar: 'إعدادات المدينين'
                },
                path: '/setting/exr',
                visible: withoutAccountingMode({
                    whenUserScreen: 'Setting_EXR'
                })
            },
            {
                text: {
                    vi: 'Dự án',
                    en: 'Project Setting',
                    fr: 'Paramètres projet',
                    es: 'Configuración proyecto',
                    id: 'Pengaturan proyek',
                    ja: 'プロジェクト設定',
                    zh: '项目设置',
                    ko: '프로젝트 설정',
                    hi: 'प्रोजेक्ट सेटिंग',
                    ar: 'إعدادات المشروع'
                },
                path: '/setting/pm',
                visible: {
                    whenUserScreen: 'Setting_PM'
                }
            },
            {
                text: {
                    vi: 'Quản lý dự án',
                    en: 'Projects',
                    fr: 'Projets',
                    es: 'Proyectos',
                    id: 'Kelola proyek',
                    ja: 'プロジェクト管理',
                    zh: '项目管理',
                    ko: '프로젝트 관리',
                    hi: 'परियोजना प्रबंधन',
                    ar: 'إدارة المشاريع'
                },
                path: '/pm/PMProjects',
                visible: {
                    whenSys: { use_Module_PM: 1 },
                    whenUser: { view_Module_PM: 1, PM_create_project: 1 }
                }
            },
            // {
            //     text: {
            //         vi: 'Tài sản',
            //         en: 'Asset Setting'
            //     },
            //     path: '/setting/fa',
            //     visible: {
            //         whenUserScreen: 'Setting_FA'
            //     }
            // },
            {
                text: {
                    vi: 'CRM',
                    en: 'CRM',
                    fr: 'CRM',
                    es: 'CRM',
                    id: 'CRM',
                    ja: 'CRM設定',
                    zh: 'CRM设置',
                    ko: 'CRM 설정',
                    hi: 'CRM सेटिंग',
                    ar: 'إعدادات CRM'
                },
                path: '/setting/crm',
                visible: {
                    whenUserScreen: 'Setting_CRM'
                }
            },
            {
                text: {
                    vi: 'Tích điểm',
                    en: 'Loyalty',
                    fr: 'Fidélité',
                    es: 'Fidelidad',
                    id: 'Loyalitas',
                    ja: 'ロイヤリティ設定',
                    zh: '忠诚度设置',
                    ko: '충성도 설정',
                    hi: 'लॉयल्टी सेटिंग',
                    ar: 'إعدادات الولاء'
                },
                path: '/setting/loyalty',
                visible: {
                    whenUserScreen: 'Setting_Loyalty'
                }
            },
            {
                text: {
                    vi: 'Hoa Hồng',
                    en: 'Commission',
                    fr: 'Commission',
                    es: 'Comisión',
                    id: 'Komisi',
                    ja: '手数料設定',
                    zh: '佣金设置',
                    ko: '수수료 설정',
                    hi: 'कमीशन सेटिंग',
                    ar: 'إعدادات العمولة'
                },
                path: '/setting/coms',
                visible: {
                    whenUserScreen: 'Setting_Commision'
                }
            },
            {
                text: {
                    vi: 'Kế toán',
                    en: 'Accounting',
                    fr: 'Paramètres comptabilité',
                    es: 'Configuración contabilidad',
                    id: 'Pengaturan akuntansi',
                    ja: '会計設定',
                    zh: '会计设置',
                    ko: '회계 설정',
                    hi: 'लेखांकन सेटिंग',
                    ar: 'إعدادات المحاسبة'
                },
                path: '/setting/gl',
                visible: withoutAccountingMode({
                    whenUserScreen: 'Setting_GL'
                })
            },
            {
                text: {
                    vi: 'Tài khoản kế toán',
                    en: 'Chart of Accounts',
                    fr: 'Plan comptable',
                    es: 'Plan de cuentas',
                    id: 'Bagan akun',
                    ja: '勘定科目表',
                    zh: '会计科目表',
                    ko: '계정과목표',
                    hi: 'खातों का चार्ट',
                    ar: 'دليل الحسابات'
                },
                path: '/deploy/GLAccounts',
                visible: withoutAccountingMode({
                    whenUserScreens: ['GLAccounts', 'GLAdjustBalances']
                })
            },
            // {
            //     text: { vi: 'Trung tâm chi phí', en: 'Cost Centers' },
            //     path: '/gl/GLCostCenters',
            //     visible: { whenUserScreen: 'GLCostCenters' }
            // },
            // {
            //     text: {
            //         vi: 'Tỷ giá hối đoái',
            //         en: 'Exchange Rates',
            //         fr: 'Taux de change',
            //         es: 'Tasas de cambio',
            //         id: 'Kurs',
            //         ja: '為替レート',
            //         zh: '汇率',
            //         ko: '환율',
            //         hi: 'विनिमय दर',
            //         ar: 'أسعار الصرف'
            //     },
            //     path: '/gl/ExchangeRates',
            //     visible: { whenUserScreen: 'ExchangeRates' }
            // },
            {
                text: {
                    vi: 'Phê duyệt',
                    en: 'Approval Rules',
                    fr: "Règles d'approbation",
                    es: 'Reglas de aprobación',
                    id: 'Aturan persetujuan',
                    ja: '承認ルール',
                    zh: '审批规则',
                    ko: '결재 규칙',
                    hi: 'अनुमोदन नियम',
                    ar: 'قواعد الموافقة'
                },
                path: '/wf/WFApprovalPolicys',
                visible: documentSettingsAccess
            },
            {
                text: {
                    vi: 'Cấu hình AI',
                    en: 'AI Config',
                    fr: 'Config IA',
                    es: 'Config IA',
                    id: 'Konfigurasi AI',
                    ja: 'AI設定',
                    zh: 'AI配置',
                    ko: 'AI 설정',
                    hi: 'AI कॉन्फ़िग',
                    ar: 'إعدادات AI'
                },
                path: '/setting/ai/AIConfig',
                visible: { whenUserScreen: 'AIConfig' }
            }
        ]
    },
    {
        text: {
            vi: 'Kết Nối',
            en: 'Connections',
            fr: 'Connexions',
            es: 'Conexiones',
            id: 'Koneksi',
            ja: '連携',
            zh: '连接',
            ko: '연결',
            hi: 'कनेक्शन',
            ar: 'الاتصالات'
        },
        icon: icon_setting,
        distinctable: false,
        visible: {
            // Cấu hình kết nối là nghiệp vụ hội sở — chỉ hiện khi đang xem "Tất cả cửa hàng"
            // (hoặc doanh nghiệp chỉ có 1 cửa hàng thì không có khái niệm phân biệt).
            when: {
                modEnabled: {
                    // Mục chỉ hiện khi ít nhất một module tích hợp được bật.
                    when: {
                        gr_sale: { whenSys: { use_Module_SaleChannel: 1 } },
                        gr_social: { whenSys: { use_Module_SocialChannel: 1 } },
                        gr_advertise: { whenSys: { use_Module_AdvertiseChannel: 1 } },
                        gr_message: { whenSys: { use_Module_MessageChannel: 1 } },
                        gr_review: { whenSys: { use_Module_ReviewChannel: 1 } },
                        gr_affiliate: { whenSys: { use_Module_AffiliateChannel: 1 } },
                        gr_carrier: { whenSys: { use_Module_CarrierChannel: 1 } },
                        gr_food: { whenSys: { use_Module_FoodChannel: 1 } }
                    },
                    whenType: 'OR'
                },
                storeScope: {
                    when: {
                        gr1: { whenSys: { store_qty: { type: '<', value: 2 } } },
                        gr2: { whenSession: { store_code: ['ALL_STORES'] } }
                    },
                    whenType: 'OR'
                }
            },
            whenType: 'AND',
            whenUserScreens: [
                'IntegrationProvidersSaleChannel',
                'IntegrationProvidersSocial',
                'IntegrationProvidersAdvertising',
                'IntegrationProvidersMessage',
                'IntegrationProvidersReviews',
                'IntegrationProvidersAffiliate',
                'IntegrationProvidersCarrier',
                'IntegrationProvidersFood'
            ]
        },
        path: '/integration/providers'
    },
    {
        // Group V1: "Theo dõi sàn TMĐT" — 3 monitoring screens cho sale channels.
        // Trong V2 module 'connect': các child sẽ flatten + map vào subGroup
        // 'connect_sale_monitor' (xem app-navigation-v2.js FLATTEN_ANCHORS + RULES).
        text: {
            vi: 'Sàn TMĐT',
            en: 'Marketplaces',
            fr: 'E-commerce',
            es: 'Marketplaces',
            id: 'E-commerce',
            ja: 'ECモール',
            zh: '电商',
            ko: '판매 채널',
            hi: 'मार्केटप्लेस',
            ar: 'الأسواق'
        },
        icon: icon_cart,
        distinctable: false,
        visible: {
            whenSys: { use_Module_SaleChannel: 1 },
            // Vận hành sàn TMĐT là nghiệp vụ hội sở — ẩn khi đang đứng ở 1 cửa hàng cụ thể.
            when: {
                gr1: { whenSys: { store_qty: { type: '<', value: 2 } } },
                gr2: { whenSession: { store_code: ['ALL_STORES'] } }
            },
            whenType: 'OR'
        },
        items: [
            {
                text: {
                    vi: 'Sàn TMĐT',
                    en: 'Marketplaces',
                    fr: 'Marketplaces',
                    es: 'Marketplaces',
                    id: 'E-commerce',
                    ja: 'ECモール',
                    zh: '电商',
                    ko: '판매 채널',
                    hi: 'मार्केटप्लेस',
                    ar: 'الأسواق الإلكترونية'
                },
                path: '/saleChannel/SaleChannelMonitor',
                visible: [
                    {
                        whenUserScreen: 'SaleChannelJobQueues',
                        when: {
                            gr1: { whenSys: { store_qty: { type: '<', value: 2 } } },
                            gr2: { whenSession: { store_code: ['ALL_STORES'] } }
                        },
                        whenType: 'OR'
                    },
                    {
                        whenUserScreen: 'SaleChannelFulfillments',
                        when: {
                            gr1: { whenSys: { store_qty: { type: '<', value: 2 } } },
                            gr2: { whenSession: { store_code: ['ALL_STORES'] } }
                        },
                        whenType: 'OR'
                    },
                    {
                        whenUserScreen: 'SaleChannelEvents',
                        when: {
                            gr1: { whenSys: { store_qty: { type: '<', value: 2 } } },
                            gr2: { whenSession: { store_code: ['ALL_STORES'] } }
                        },
                        whenType: 'OR'
                    }
                ]
            }
        ]
    },
    {
        // Group V1: "Theo dõi mạng xã hội" — 2 monitoring screens cho social channels.
        // Trong V2 module 'connect': flatten + subGroup 'connect_social_monitor'.
        text: {
            vi: 'Mạng xã hội',
            en: 'Social',
            fr: 'Social',
            es: 'Social',
            id: 'Sosial',
            ja: 'ソーシャル',
            zh: '社交',
            ko: '소셜',
            hi: 'सोशल',
            ar: 'القنوات الاجتماعية'
        },
        icon: icon_customer,
        distinctable: false,
        visible: {
            whenSys: { use_Module_SocialChannel: 1 },
            // Vận hành mạng xã hội là nghiệp vụ hội sở — ẩn khi đang đứng ở 1 cửa hàng cụ thể.
            when: {
                gr1: { whenSys: { store_qty: { type: '<', value: 2 } } },
                gr2: { whenSession: { store_code: ['ALL_STORES'] } }
            },
            whenType: 'OR'
        },
        items: [
            {
                text: {
                    vi: 'Mạng xã hội',
                    en: 'Social',
                    fr: 'Réseaux sociaux',
                    es: 'Redes sociales',
                    id: 'Media sosial',
                    ja: 'ソーシャル',
                    zh: '社交媒体',
                    ko: '소셜',
                    hi: 'सोशल मीडिया',
                    ar: 'وسائل التواصل'
                },
                path: '/socialChannel/SocialChannelMonitor',
                visible: [
                    { whenUserScreen: 'SocialChannelJobQueues' },
                    { whenUserScreen: 'SocialChannelEvents' }
                ]
            }
        ]
    },
    {
        // Group V1: "Vận hành kết nối" — các màn vận hành Email/SMS, Quảng cáo, Đánh giá.
        // Trong V2 module 'connect': flatten → mỗi child tự resolvePath qua RULES vào subGroup
        // riêng (connect_message / connect_advertise / connect_review).
        // Anchor flatten = '/marketing/MKGDeliveryLog' (xem app-navigation-v2.js FLATTEN_ANCHORS).
        text: {
            vi: 'Vận hành kết nối',
            en: 'Connection Ops',
            fr: 'Opérations',
            es: 'Operaciones',
            id: 'Operasi',
            ja: '連携運用',
            zh: '连接运营',
            ko: '연동 운영',
            hi: 'संचालन',
            ar: 'العمليات'
        },
        icon: icon_delivery,
        distinctable: false,
        visible: {
            // Vận hành kết nối là nghiệp vụ hội sở — ẩn khi đang đứng ở 1 cửa hàng cụ thể.
            when: {
                modEnabled: {
                    when: {
                        gr_msg: { whenSys: { use_Module_MessageChannel: 1 } },
                        gr_ad: { whenSys: { use_Module_AdvertiseChannel: 1 } },
                        gr_rv: { whenSys: { use_Module_ReviewChannel: 1 } }
                    },
                    whenType: 'OR'
                },
                storeScope: {
                    when: {
                        gr1: { whenSys: { store_qty: { type: '<', value: 2 } } },
                        gr2: { whenSession: { store_code: ['ALL_STORES'] } }
                    },
                    whenType: 'OR'
                }
            },
            whenType: 'AND'
        },
        items: [
            {
                text: {
                    vi: 'Email & SMS',
                    en: 'Email & SMS',
                    fr: 'Email et SMS',
                    es: 'Email y SMS',
                    id: 'Email & SMS',
                    ja: 'メール・SMS',
                    zh: '邮件与短信',
                    ko: '이메일·SMS',
                    hi: 'ईमेल और SMS',
                    ar: 'البريد والرسائل'
                },
                path: '/marketing/MessageChannelMonitor',
                visible: [
                    { whenUserScreen: 'MKGDeliveryLogs' },
                    { whenUserScreen: 'MKGOptOuts' }
                ]
            },
            {
                text: {
                    vi: 'Quảng cáo',
                    en: 'Advertising',
                    fr: 'Publicité',
                    es: 'Publicidad',
                    id: 'Iklan',
                    ja: '広告',
                    zh: '广告',
                    ko: '광고',
                    hi: 'विज्ञापन',
                    ar: 'الإعلانات'
                },
                path: '/marketing/AdvertiseChannelMonitor',
                visible: { whenUserScreen: 'MKGConversionEvents' }
            },
            {
                text: {
                    vi: 'Đánh giá',
                    en: 'Reviews',
                    fr: 'Avis',
                    es: 'Reseñas',
                    id: 'Ulasan',
                    ja: 'レビュー',
                    zh: '评价',
                    ko: '리뷰',
                    hi: 'समीक्षाएं',
                    ar: 'التقييمات'
                },
                path: '/marketing/ReviewChannelMonitor',
                visible: { whenUserScreen: 'MKGReviews' }
            }
        ]
    },
    {
        // Group V1: "Affiliate" — 4 màn vận hành tiếp thị liên kết.
        // Trong V2 module 'connect': flatten → mỗi child resolvePath qua RULES vào subGroup
        // 'connect_affiliate'. Anchor flatten = '/marketing/MKGAffOffer'.
        text: {
            vi: 'Affiliate',
            en: 'Affiliate',
            fr: 'Affiliation',
            es: 'Afiliados',
            id: 'Afiliasi',
            ja: 'アフィリエイト',
            zh: '联盟营销',
            ko: '제휴',
            hi: 'सहबद्ध',
            ar: 'التسويق بالعمولة'
        },
        icon: icon_commision,
        distinctable: false,
        visible: {
            whenSys: { use_Module_AffiliateChannel: 1 },
            // Vận hành affiliate là nghiệp vụ hội sở — ẩn khi đang đứng ở 1 cửa hàng cụ thể.
            when: {
                gr1: { whenSys: { store_qty: { type: '<', value: 2 } } },
                gr2: { whenSession: { store_code: ['ALL_STORES'] } }
            },
            whenType: 'OR'
        },
        items: [
            {
                text: {
                    vi: 'Affiliate',
                    en: 'Affiliate',
                    fr: 'Affiliation',
                    es: 'Afiliados',
                    id: 'Afiliasi',
                    ja: 'アフィリエイト',
                    zh: '联盟营销',
                    ko: '제휴',
                    hi: 'सहबद्ध',
                    ar: 'التسويق بالعمولة'
                },
                path: '/marketing/AffiliateChannelMonitor',
                visible: [
                    { whenUserScreen: 'MKGAffOffers' },
                    { whenUserScreen: 'MKGAffPublishers' },
                    { whenUserScreen: 'MKGAffTrackingLinks' },
                    { whenUserScreen: 'MKGAffPostbacks' }
                ]
            }
        ]
    },
    {
        // Group V1: "Vận chuyển" — 3 màn vận hành tích hợp đơn vị vận chuyển (INT carrier domain).
        // Trong V2 module 'connect': flatten → mỗi child resolvePath qua RULES vào subGroup
        // 'connect_carrier'. Anchor flatten = '/carrier/INTCarrierOrders'.
        text: {
            vi: 'Vận chuyển',
            en: 'Carriers',
            fr: 'Transporteurs',
            es: 'Transportistas',
            id: 'Pengiriman',
            ja: '配送',
            zh: '物流',
            ko: '배송',
            hi: 'शिपिंग',
            ar: 'الشحن'
        },
        icon: icon_delivery,
        distinctable: false,
        visible: {
            // Gate theo module KẾT NỐI vận chuyển (khớp gate 3 màn con INTCarrier* trong ACUserScreens)
            // — trước dùng use_Module_LG khiến business LG-on/carrier-off thấy group rỗng trong nav V1.
            whenSys: { use_Module_CarrierChannel: 1 },
            // Vận hành kết nối vận chuyển là nghiệp vụ hội sở — ẩn khi đang đứng ở 1 cửa hàng cụ thể.
            when: {
                gr1: { whenSys: { store_qty: { type: '<', value: 2 } } },
                gr2: { whenSession: { store_code: ['ALL_STORES'] } }
            },
            whenType: 'OR'
        },
        items: [
            {
                text: {
                    vi: 'Vận chuyển',
                    en: 'Carriers',
                    fr: 'Transporteurs',
                    es: 'Transportistas',
                    id: 'Pengiriman',
                    ja: '配送',
                    zh: '物流',
                    ko: '배송',
                    hi: 'शिपिंग',
                    ar: 'الشحن'
                },
                path: '/carrier/INTCarrierMonitor',
                visible: [
                    { whenUserScreen: 'INTCarrierOrders' },
                    { whenUserScreen: 'INTCarrierEvents' },
                    { whenUserScreen: 'INTCarrierJobQueues' }
                ]
            }
        ]
    },
    {
        // Một điểm vào giám sát giao đồ ăn; đơn, nhật ký và tác vụ nằm trong các tab.
        text: {
            vi: 'Giao đồ ăn',
            en: 'Food Delivery',
            fr: 'Livraison de repas',
            es: 'Entrega de comida',
            id: 'Pesan antar makanan',
            ja: 'フードデリバリー',
            zh: '外卖配送',
            ko: '음식 배달',
            hi: 'फूड डिलीवरी',
            ar: 'توصيل الطعام'
        },
        icon: icon_delivery,
        distinctable: false,
        visible: {
            whenSys: { use_Module_FoodChannel: 1 },
            when: {
                gr1: { whenSys: { store_qty: { type: '<', value: 2 } } },
                gr2: { whenSession: { store_code: ['ALL_STORES'] } }
            },
            whenType: 'OR'
        },
        items: [
            {
                text: {
                    vi: 'Giao đồ ăn',
                    en: 'Food Delivery',
                    fr: 'Livraison de repas',
                    es: 'Entrega de comida',
                    id: 'Pesan antar makanan',
                    ja: 'フードデリバリー',
                    zh: '外卖配送',
                    ko: '음식 배달',
                    hi: 'फूड डिलीवरी',
                    ar: 'توصيل الطعام'
                },
                path: '/food/FoodDeliveryMonitor',
                visible: { whenUserScreen: 'IntegrationProvidersFood' }
            }
        ]
    },
    {
        text: {
            vi: 'Phân Quyền',
            en: 'Permission',
            fr: 'Autorisations',
            es: 'Permiso',
            id: 'Izin',
            ja: '権限',
            zh: '权限',
            ko: '권한',
            hi: 'अनुमति',
            ar: 'الإذن'
        },
        icon: icon_permision,
        distinctable: false,
        visible: {
            when: {
                gr1: {
                    whenSys: {
                        store_qty: { type: '<', value: 2 }
                    }
                },
                gr2: {
                    whenSession: {
                        store_code: ['ALL_STORES']
                    }
                }
            },
            whenType: 'OR'
        },
        items: [
            // {
            //     text: {
            //         vi: 'Người dùng',
            //         en: 'User Account',
            //         fr: 'Compte utilisateur',
            //         es: 'Cuenta usuario',
            //         id: 'Akun pengguna',
            //         ja: 'ユーザーアカウント',
            //         zh: '用户账户',
            //         ko: '사용자 계정',
            //         hi: 'उपयोगकर्ता खाता',
            //         ar: 'حساب المستخدم'
            //     },
            //     path: '/user/ACUserAccounts',
            //     visible: {
            //         whenUserScreen: 'ACUserAccounts'
            //     }
            // },
            // {
            //     text: {
            //         vi: 'Phân Quyền',
            //         en: 'User Group',
            //         fr: 'Groupe utilisateurs',
            //         es: 'Grupo usuarios',
            //         id: 'Grup pengguna',
            //         ja: 'ユーザーグループ',
            //         zh: '用户组',
            //         ko: '사용자 그룹',
            //         hi: 'उपयोगकर्ता समूह',
            //         ar: 'مجموعة المستخدمين'
            //     },
            //     path: '/user/ACUserGroups',
            //     visible: {
            //         whenUserScreen: 'ACUserGroups'
            //     }
            // }
            // {
            //     text: {
            //         vi: 'Phê duyệt',
            //         en: 'Approval'
            //     },
            //     path: '/user/ACUserApprovals',
            //     visible: {
            //         whenUserScreen: 'ACUserApprovals'
            //     }
            // }
        ]
    },
    {
        text: {
            vi: 'Hệ thống',
            en: 'System',
            fr: 'Système',
            es: 'Sistema',
            id: 'Sistem',
            ja: 'システム',
            zh: '系统',
            ko: '시스템',
            hi: 'सिस्टम',
            ar: 'النظام'
        },
        icon: icon_account,
        distinctable: false,
        visible: {
            when: {
                gr1: {
                    whenSys: {
                        store_qty: { type: '<', value: 2 }
                    }
                },
                gr2: {
                    whenSession: {
                        store_code: ['ALL_STORES']
                    }
                }
            },
            whenType: 'OR'
        },
        items: [
            {
                text: {
                    vi: 'Hệ thống',
                    en: 'System Config',
                    fr: 'Config système',
                    es: 'Config sistema',
                    id: 'Konfigurasi sistem',
                    ja: 'システム設定',
                    zh: '系统配置',
                    ko: '시스템 설정',
                    hi: 'सिस्टम कॉन्फ़िग',
                    ar: 'إعدادات النظام'
                },
                path: '/setting/sys',
                visible: {
                    whenUserScreen: 'SettingSys'
                }
            },
            // {
            //     text: {
            //         vi: 'Dữ liệu',
            //         en: 'System Data',
            //         fr: 'Données système',
            //         es: 'Datos sistema',
            //         id: 'Data sistem',
            //         ja: 'システムデータ',
            //         zh: '系统数据',
            //         ko: '시스템 데이터',
            //         hi: 'सिस्टम डेटा',
            //         ar: 'بيانات النظام'
            //     },
            //     path: '/setting/sys/data',
            //     visible: {
            //         whenUserScreen: 'SettingSysData'
            //     }
            // },
            {
                text: {
                    vi: 'Kiểm tra dữ liệu',
                    en: 'Data Audit',
                    fr: 'Audit données',
                    es: 'Auditoría datos',
                    id: 'Audit Data',
                    ja: 'データ監査',
                    zh: '数据审计',
                    ko: '데이터 감사',
                    hi: 'डेटा ऑडिट',
                    ar: 'تدقيق البيانات'
                },
                path: '/setting/sys/SysDataAudits',
                visible: {
                    whenUserScreen: 'SysDataAudits'
                }
            },
            {
                text: {
                    vi: 'Sao lưu dữ liệu',
                    en: 'Data Backup',
                    fr: 'Sauvegarde données',
                    es: 'Copia de seguridad',
                    id: 'Cadangan Data',
                    ja: 'データバックアップ',
                    zh: '数据备份',
                    ko: '데이터 백업',
                    hi: 'डेटा बैकअप',
                    ar: 'نسخ البيانات'
                },
                path: '/setting/sys/SysDataBackups',
                visible: {
                    whenUserScreen: 'SysDataBackups'
                }
            },
            {
                text: {
                    vi: 'Triển khai',
                    en: 'Deployment',
                    fr: 'Déploiement',
                    es: 'Despliegue',
                    id: 'Penyebaran',
                    ja: 'デプロイメント',
                    zh: '部署',
                    ko: '배포',
                    hi: 'परिनियोजन',
                    ar: 'النشر'
                },
                path: '/deployment/',
                // 24/10: có gói Kế toán thì Số dư đầu kỳ chỉ ở chế độ Kế toán (SD-01); chỉ Admin mở, Admin luôn vào được chế độ Kế toán.
                visible: withoutAccountingMode({
                    whenSession: { user_group_code: ['Admin'] }
                })
            },
            {
                text: {
                    vi: 'Người dùng',
                    en: 'User Account',
                    fr: 'Compte utilisateur',
                    es: 'Cuenta usuario',
                    id: 'Akun pengguna',
                    ja: 'ユーザーアカウント',
                    zh: '用户账户',
                    ko: '사용자 계정',
                    hi: 'उपयोगकर्ता खाता',
                    ar: 'حساب المستخدم'
                },
                path: '/user/ACUserAccounts',
                visible: {
                    whenUserScreen: 'ACUserAccounts'
                }
            },
            {
                text: {
                    vi: 'Phân Quyền',
                    en: 'User Group',
                    fr: 'Groupe utilisateurs',
                    es: 'Grupo usuarios',
                    id: 'Grup pengguna',
                    ja: 'ユーザーグループ',
                    zh: '用户组',
                    ko: '사용자 그룹',
                    hi: 'उपयोगकर्ता समूह',
                    ar: 'مجموعة المستخدمين'
                },
                path: '/user/ACUserGroups',
                visible: {
                    whenUserScreen: 'ACUserGroups'
                }
            }
        ]
    },
    {
        text: {
            vi: 'Nhượng quyền',
            en: 'Franchise',
            fr: 'Franchise',
            es: 'Franquicia',
            id: 'Waralaba',
            ja: 'フランチャイズ',
            zh: '特许经营',
            ko: '프랜차이즈',
            hi: 'फ्रैंचाइज़',
            ar: 'امتياز'
        },
        icon: 'globe',
        visible: { whenUserScreen: 'B2BSupplierPartners' },
        items: [
            {
                text: {
                    vi: 'Cửa hàng nhượng quyền',
                    en: 'Franchise Stores',
                    fr: 'Magasins franchisés',
                    es: 'Tiendas',
                    id: 'Toko waralaba',
                    ja: '加盟店',
                    zh: '加盟店',
                    ko: '가맹점',
                    hi: 'फ्रैंचाइज़ स्टोर',
                    ar: 'متاجر الامتياز'
                },
                path: '/b2b/B2BSupplierPartners',
                visible: { whenUserScreen: 'B2BSupplierPartners' }
            },
            {
                text: {
                    vi: 'Catalog sản phẩm',
                    en: 'Product Catalogs',
                    fr: 'Catalogues',
                    es: 'Catálogos',
                    id: 'Katalog',
                    ja: 'カタログ',
                    zh: '产品目录',
                    ko: '카탈로그',
                    hi: 'कैटलॉग',
                    ar: 'الكتالوجات'
                },
                path: '/b2b/B2BCatalogs',
                visible: { whenUserScreen: 'B2BCatalogs' }
            },
            {
                text: {
                    vi: 'Đơn bán B2B',
                    en: 'B2B Sales Orders',
                    fr: 'Commandes vente B2B',
                    es: 'Pedidos venta B2B',
                    id: 'Pesanan penjualan B2B',
                    ja: 'B2B販売注文',
                    zh: 'B2B销售订单',
                    ko: 'B2B 판매',
                    hi: 'B2B बिक्री',
                    ar: 'طلبات البيع B2B'
                },
                path: '/b2b/B2BSupplierOrders',
                visible: { whenUserScreen: 'B2BSupplierOrders' },
                navBadge: { module: 'b2b', table: 'B2BOrder', searchConditions: { order_status: 'Submitted' } }
            }
        ]
    },
    {
        text: {
            vi: 'Đặt hàng NCC',
            en: 'B2B Purchasing',
            fr: 'Achats B2B',
            es: 'Compras B2B',
            id: 'Pembelian B2B',
            ja: 'B2B仕入',
            zh: 'B2B采购',
            ko: 'B2B 구매',
            hi: 'B2B खरीद',
            ar: 'مشتريات B2B'
        },
        icon: icon_purchase,
        visible: { whenUserScreen: 'B2BBuyerPartners' },
        items: [
            {
                text: {
                    vi: 'Nhà cung cấp',
                    en: 'Suppliers',
                    fr: 'Fournisseurs',
                    es: 'Proveedores',
                    id: 'Pemasok',
                    ja: '仕入先',
                    zh: '供应商',
                    ko: '공급업체',
                    hi: 'आपूर्तिकर्ता',
                    ar: 'الموردون'
                },
                path: '/b2b/B2BBuyerPartners',
                visible: { whenUserScreen: 'B2BBuyerPartners' }
            },
            {
                text: {
                    vi: 'Đơn đặt hàng',
                    en: 'Purchase Orders',
                    fr: 'Commandes achat',
                    es: 'Pedidos compra',
                    id: 'Pesanan pembelian',
                    ja: '発注',
                    zh: '采购订单',
                    ko: '구매 주문',
                    hi: 'खरीद ऑर्डर',
                    ar: 'أوامر الشراء'
                },
                path: '/b2b/B2BBuyerOrders',
                visible: { whenUserScreen: 'B2BBuyerOrders' },
                navBadge: { module: 'b2b', table: 'B2BOrder', searchConditions: { order_status: 'Submitted' } }
            },
            {
                text: {
                    vi: 'Ánh xạ sản phẩm',
                    en: 'Item Mapping',
                    fr: 'Mapping produits',
                    es: 'Mapeo',
                    id: 'Pemetaan',
                    ja: 'マッピング',
                    zh: '映射',
                    ko: '매핑',
                    hi: 'मैपिंग',
                    ar: 'ربط'
                },
                path: '/b2b/B2BItemMappings',
                visible: { whenUserScreen: 'B2BItemMappings' }
            }
        ]
    },
    {
        text: {
            vi: 'Sàn TMĐT',
            en: 'Sale Channel',
            fr: 'Marketplaces',
            es: 'Canales de venta',
            id: 'Saluran penjualan',
            ja: 'ECモール',
            zh: '电商平台',
            ko: '판매 채널',
            hi: 'विक्रय चैनल',
            ar: 'قنوات البيع'
        },
        icon: icon_cart,
        visible: { whenUserScreen: 'SaleChannelApps' },
        items: [
            {
                text: {
                    vi: 'Kết nối sàn',
                    en: 'Connections',
                    fr: 'Connexions',
                    es: 'Conexiones',
                    id: 'Koneksi',
                    ja: '接続',
                    zh: '连接',
                    ko: '연결',
                    hi: 'कनेक्शन',
                    ar: 'الاتصالات'
                },
                path: '/saleChannel/SaleChannelApps',
                // Hidden — provider landing moved to /integration/providers (Cấu Hình group).
                // Item giữ lại làm FLATTEN_ANCHORS anchor cho v2 nav (xem app-navigation-v2.js).
                visible: false
            }
            // Monitoring items (Fulfillments/Events/JobQueues) đã chuyển sang
            // top-level group "Theo dõi kết nối" + module 'connect' (v2).
            // SaleChannelOrders đã chuyển sang /integration/Orders (multi-tab) trong
            // module Bán hàng. Legacy paths vẫn route được — chờ user verify rồi xoá.
        ]
    },
    {
        text: {
            vi: 'Kênh xã hội',
            en: 'Social Channel',
            fr: 'Canaux sociaux',
            es: 'Canales sociales',
            id: 'Saluran sosial',
            ja: 'ソーシャル',
            zh: '社交渠道',
            ko: '소셜 채널',
            hi: 'सोशल चैनल',
            ar: 'القنوات الاجتماعية'
        },
        icon: icon_customer,
        visible: {
            whenUserScreen: 'SocialChannelApps',
            // Cấu hình/vận hành kênh xã hội (mẫu tin, tự động, báo cáo) là nghiệp vụ hội sở —
            // ẩn khi đang đứng ở 1 cửa hàng cụ thể.
            when: {
                gr1: { whenSys: { store_qty: { type: '<', value: 2 } } },
                gr2: { whenSession: { store_code: ['ALL_STORES'] } }
            },
            whenType: 'OR'
        },
        items: [
            {
                text: {
                    vi: 'Kết nối kênh',
                    en: 'Connections',
                    fr: 'Connexions',
                    es: 'Conexiones',
                    id: 'Koneksi',
                    ja: '接続',
                    zh: '连接',
                    ko: '연결',
                    hi: 'कनेक्शन',
                    ar: 'الاتصالات'
                },
                path: '/socialChannel/SocialChannelApps',
                // Hidden — provider landing moved to /integration/providers (Cấu Hình group).
                // Item giữ lại làm FLATTEN_ANCHORS anchor cho v2 nav (xem app-navigation-v2.js).
                visible: false
            },
            {
                text: {
                    vi: 'Mẫu tin',
                    en: 'Templates',
                    fr: 'Modèles',
                    es: 'Plantillas',
                    id: 'Templat',
                    ja: 'テンプレート',
                    zh: '模板',
                    ko: '템플릿',
                    hi: 'टेम्पलेट',
                    ar: 'قوالب'
                },
                path: '/socialChannel/SocialTemplates',
                visible: {
                    whenUserScreen: 'SocialTemplates',
                    when: {
                        gr1: { whenSys: { store_qty: { type: '<', value: 2 } } },
                        gr2: { whenSession: { store_code: ['ALL_STORES'] } }
                    },
                    whenType: 'OR'
                }
            },
            {
                text: {
                    vi: 'Tự động',
                    en: 'Automation',
                    fr: 'Automatisation',
                    es: 'Automatización',
                    id: 'Otomatis',
                    ja: '自動化',
                    zh: '自动化',
                    ko: '자동화',
                    hi: 'स्वचालन',
                    ar: 'أتمتة'
                },
                path: '/socialChannel/SocialAutoRules',
                visible: {
                    whenUserScreen: 'SocialAutoRules',
                    when: {
                        gr1: { whenSys: { store_qty: { type: '<', value: 2 } } },
                        gr2: { whenSession: { store_code: ['ALL_STORES'] } }
                    },
                    whenType: 'OR'
                }
            },
            {
                text: {
                    vi: 'Báo cáo',
                    en: 'Reports',
                    fr: 'Rapports',
                    es: 'Informes',
                    id: 'Laporan',
                    ja: 'レポート',
                    zh: '报表',
                    ko: '보고서',
                    hi: 'रिपोर्ट',
                    ar: 'تقارير'
                },
                path: '/socialChannel/SocialReport',
                visible: {
                    whenUserScreen: 'SocialReport',
                    when: {
                        gr1: { whenSys: { store_qty: { type: '<', value: 2 } } },
                        gr2: { whenSession: { store_code: ['ALL_STORES'] } }
                    },
                    whenType: 'OR'
                }
            }
            // SocialOrders đã chuyển sang /integration/Orders (multi-tab) module Bán hàng.
            // SocialChannelEvents + SocialChannelJobQueues đã chuyển sang group
            // "Theo dõi kết nối" + module 'connect' (v2).
        ]
    },
    {
        text: { vi: 'AI', en: 'AI', fr: 'IA', es: 'IA', id: 'AI', ja: 'AI', zh: 'AI', ko: 'AI', hi: 'AI', ar: 'AI' },
        icon: 'lightning',
        visible: { whenUserScreen: 'AIWorkspace' },
        visible: false,
        items: [
            {
                text: {
                    vi: 'Trợ lý AI',
                    en: 'AI Assistant',
                    fr: 'Assistant IA',
                    es: 'Asistente IA',
                    id: 'Asisten AI',
                    ja: 'AIアシスタント',
                    zh: 'AI助手',
                    ko: 'AI 도우미',
                    hi: 'AI सहायक',
                    ar: 'مساعد AI'
                },
                path: '/ai/AIWorkspace',
                visible: { whenUserScreen: 'AIWorkspace' }
            },
            {
                text: {
                    vi: 'Tài liệu AI',
                    en: 'AI Documents',
                    fr: 'Documents IA',
                    es: 'Documentos IA',
                    id: 'Dokumen AI',
                    ja: 'AIドキュメント',
                    zh: 'AI文档',
                    ko: 'AI 문서',
                    hi: 'AI दस्तावेज़',
                    ar: 'مستندات AI'
                },
                path: '/ai/AIJobQueues',
                visible: { whenUserScreen: 'AIJobQueues' }
            },
            {
                text: {
                    vi: 'Nguồn tài liệu',
                    en: 'Document Sources',
                    fr: 'Sources',
                    es: 'Fuentes',
                    id: 'Sumber',
                    ja: 'ソース',
                    zh: '来源',
                    ko: '소스',
                    hi: 'स्रोत',
                    ar: 'مصادر'
                },
                path: '/ai/AIDocumentSources',
                visible: { whenUserScreen: 'AIDocumentSources' }
            },
            {
                text: {
                    vi: 'Kiến thức AI',
                    en: 'AI Knowledge',
                    fr: 'Connaissances IA',
                    es: 'Conocimiento IA',
                    id: 'Pengetahuan AI',
                    ja: 'AIナレッジ',
                    zh: 'AI知识',
                    ko: 'AI 지식',
                    hi: 'AI ज्ञान',
                    ar: 'معرفة AI'
                },
                path: '/ai/AIKnowledgeBases',
                visible: { whenUserScreen: 'AIKnowledgeBases' }
            }
        ]
    },
    {
        text: {
            vi: 'Tài liệu',
            en: 'Documents',
            fr: 'Documents',
            es: 'Documentos',
            id: 'Dokumen',
            ja: 'ドキュメント',
            zh: '文档',
            ko: '문서',
            hi: 'दस्तावेज़',
            ar: 'المستندات'
        },
        icon: 'folder',
        visible: { whenUserScreen: 'AIImportBatchs' },
        items: [
            {
                text: {
                    vi: 'Lô phân tích AI',
                    en: 'AI Import Batches',
                    fr: 'Lots IA',
                    es: 'Lotes IA',
                    id: 'Batch AI',
                    ja: 'AIインポートバッチ',
                    zh: 'AI批次',
                    ko: 'AI 배치',
                    hi: 'AI बैच',
                    ar: 'دفعات AI'
                },
                path: '/ai/AIImportBatchs',
                visible: { whenUserScreen: 'AIImportBatchs' }
            }
        ]
    }
];
